import Vue from 'vue';
import i18n from "@/i18n";
import store from "@/store";
import vuetify from './plugins/vuetify';

function shopName() {
  return store.state.settings && store.state.settings.shop_custom_name
    ? store.state.settings.shop_custom_name
    : i18n.t("Shop.default_shop_name");
}
function setShopName(str) {
  return i18n.t(str, [shopName()])
}
Vue.filter('setShopName', setShopName);

function allianceName() {
  return store.state.settings && store.state.settings.agent_custom_name
    ? store.state.settings.agent_custom_name
    : i18n.t("Alliances.default_alliance_name");
}
function setAllianceName(str) {
  return i18n.t(str, [allianceName()])
}
Vue.filter('setAllianceName', setAllianceName);
function maxValue() {
  return 99999999;
}
function setMaxValue(num) {
  return i18n.t(num, [maxValue()])
}
Vue.filter('setMaxValue', setMaxValue);

var cancelFlgs = [
  {
    text: i18n.t("CancelFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("CancelFlgs.on"),
    color: "grey",
    textColor: "white",
    value: 1
  }
];
// 查找cancelFlgs
function cancelFlgsItem(value) {
  value = value ? 1 : 0;// 有值都当on
  return cancelFlgs.find((element) => element.value == value);
}
function cancelFlgsText(value) {
  return cancelFlgsItem(value).text;
}
Vue.filter('cancelFlgsText', cancelFlgsText);
function cancelFlgsColor(value) {
  return cancelFlgsItem(value).color;
}
Vue.filter('cancelFlgsColor', cancelFlgsColor);
function cancelFlgsTextColor(value) {
  return cancelFlgsItem(value).textColor;
}
Vue.filter('cancelFlgsTextColor', cancelFlgsTextColor);

// 是否超收/超付
var beyondStatus = [
  {
    text: i18n.t("Receipt.beyondStatus.no"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Receipt.beyondStatus.overcharge"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Receipt.beyondStatus.overpay"),
    color: "primary",
    textColor: "white",
    value: 3,
  }
];
function beyondStatusItem(value) {
  var item = beyondStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function beyondStatusText(value) {
  return beyondStatusItem(value).text;
}
Vue.filter('beyondStatusText', beyondStatusText);
function beyondStatusColor(value) {
  return beyondStatusItem(value).color;
}
Vue.filter('beyondStatusColor', beyondStatusColor);
function beyondStatusTextColor(value) {
  return beyondStatusItem(value).textColor;
}
Vue.filter('beyondStatusTextColor', beyondStatusTextColor);


var orderStatus = [
  {
    text: i18n.t("Order.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Order.status.confirmed"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Order.status.granted"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Order.status.out_stock"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("Order.status.distributed"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("Order.status.finished"),
    color: "primary",
    textColor: "white",
    value: 6,
  },
];
// 查找Status
function orderStatusItem(value) {
  var item = orderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function orderStatusText(value) {
  return orderStatusItem(value).text;
}
Vue.filter('orderStatusText', orderStatusText);
function orderStatusColor(value) {
  return orderStatusItem(value).color;
}
Vue.filter('orderStatusColor', orderStatusColor);
function orderStatusTextColor(value) {
  return orderStatusItem(value).textColor;
}
Vue.filter('orderStatusTextColor', orderStatusTextColor);
var orderErrorFlg = [
  {
    text: i18n.t("Order.error_flg.redeliver"),
    color: "danger",
    textColor: "white",
    value: 1,
  }
];

var presaleFlgs = [
  {
    text: i18n.t("Order.presale_flgs.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Order.presale_flgs.off"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
];
// 查找Status
function presaleFlgsItem(value) {
  var item = presaleFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function presaleFlgsText(value) {
  return presaleFlgsItem(value).text;
}
Vue.filter('presaleFlgsText', presaleFlgsText);
function presaleFlgsColor(value) {
  return presaleFlgsItem(value).color;
}
Vue.filter('presaleFlgsColor', presaleFlgsColor);
function presaleFlgsTextColor(value) {
  return presaleFlgsItem(value).textColor;
}
Vue.filter('presaleFlgsTextColor', presaleFlgsTextColor);

// 供应商管理 状态
var stop_flg = [
  {
    text: i18n.t("Supplier.status.on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Supplier.status.off"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
]
function stopFlgItem(value) {
  var item = stop_flg.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stopFlgText(value) {
  return stopFlgItem(value).text
}
Vue.filter('stopFlgText', stopFlgText)
function stopFlgColor(value) {
  return stopFlgItem(value).color
}
Vue.filter('stopFlgColor', stopFlgColor)
function stopFlgTextColor(value) {
  return stopFlgItem(value).textColor
}
Vue.filter('stopFlgTextColor', stopFlgTextColor)
// tax_flg 是否含税
// var tax_flg = [
//   {
//     text: i18n.t("SupplierMaterials.Fields.sale_on"),
//     color: "primary",
//     textColor: "white",
//     value: "1",
//   },
//   {
//     text: i18n.t("SupplierMaterials.Fields.sale_off"),
//     value: "0",
//   },
// ]
// 供应商设定 是否在售
var public_flg = [
  {
    text: i18n.t("SupplierMaterials.Fields.sale_on"),
    color: "primary",
    textColor: "white",
    value: "1",
  },
  {
    text: i18n.t("SupplierMaterials.Fields.sale_off"),
    value: "0",
  },
]
function publicFlgItem(value) {
  var item = public_flg.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function publicFlgText(value) {
  return publicFlgItem(value).text
}
Vue.filter('publicFlgText', publicFlgText)
function publicFlgColor(value) {
  return publicFlgItem(value).color

}
Vue.filter('publicFlgColor', publicFlgColor)
function publicFlgTextColor(value) {
  return publicFlgItem(value).textColor
}
Vue.filter('publicFlgTextColor', publicFlgTextColor)


// 供应商区分
var supply_type = [
  {
    text: i18n.t("Supplier.SupplyType.common"),
    value: "1",
  },
  {
    text: i18n.t("Supplier.SupplyType.platform"),
    value: "2",
  },
]
function supplyTypeItem(value) {
  var item = supply_type.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function supplyTypeText(value) {
  return supplyTypeItem(value).text
}
Vue.filter('supplyTypeText', supplyTypeText)
function supplyTypeColor() {
  return "";
}
Vue.filter('supplyTypeColor', supplyTypeColor)
function supplyTypeTextColor() {
  return "";
}
Vue.filter('supplyTypeTextColor', supplyTypeTextColor)

// 供应商评级
var supplier_level = [
  {
    text: i18n.t("SupplierCriteriaSetting.supplierClassification.A"),
    color: "primary",
    textColor: "white",
    value: "A",
  },
  {
    text: i18n.t("SupplierCriteriaSetting.supplierClassification.B"),
    color: "orange",
    textColor: "white",
    value: "B",
  },
  {
    text: i18n.t("SupplierCriteriaSetting.supplierClassification.C"),
    color: "accent",
    textColor: "white",
    value: "C",
  },
  {
    text: i18n.t("SupplierCriteriaSetting.supplierClassification.D"),
    color: "danger",
    textColor: "white",
    value: "D",
  },
]
function supplierLevelItem(value) {
  var item = supplier_level.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function supplierLevelText(value) {
  return supplierLevelItem(value).text
}
Vue.filter('supplierLevelText', supplierLevelText)
function supplierLevelColor(value) {
  return supplierLevelItem(value).color

}
Vue.filter('supplierLevelColor', supplierLevelColor)
function supplierLevelTextColor(value) {
  return supplierLevelItem(value).textColor
}
Vue.filter('supplierLevelTextColor', supplierLevelTextColor)

// 采购单来源
var origin_flgs = [
  {
    text: i18n.t("PurchasesList.originFlgs.purchase"),
    value: "101",
  },
  {
    text: i18n.t("PurchasesList.originFlgs.order_purchase"),
    value: "102",
  },
  {
    text: i18n.t("PurchasesList.originFlgs.smart"),
    value: "103",
  },
  {
    text: i18n.t("PurchasesList.originFlgs.supplier"),
    value: "104",
  },
  {
    text: i18n.t("PurchasesList.originFlgs.default_import"),
    value: "201",
  },
  // {
  //   text: i18n.t("PurchasesList.originFlgs.donkey"),
  //   value: "202",
  // },
  {
    text: i18n.t("PurchasesList.originFlgs.norm"),
    value: "301",
  },
]
function originFlgsItem(value) {
  var item = origin_flgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("PurchasesList.originFlgs.purchase"),
    // color: "gray",
    // textColor: "white",
    value: "101",
  };
}
function originFlgsText(value) {
  return originFlgsItem(value).text;
}
Vue.filter('originFlgsText', originFlgsText);
function originFlgsColor() {
  return "";
}
Vue.filter('originFlgsColor', originFlgsColor);
function originFlgsTextColor() {
  return "";
}
Vue.filter('originFlgsTextColor', originFlgsTextColor);

// 重置值
function orderOriginFlgs() {
  return [
    {
      text: i18n.t("Order.originFlgs.account"),
      value: "001",
    },
    {
      text: i18n.t("Order.originFlgs.shop", [shopName()]),
      value: "002",
    },
    {
      text: i18n.t("Order.originFlgs.shop_android"),
      value: "101",
    },
    {
      text: i18n.t("Order.originFlgs.shop_ios"),
      value: "102",
    },
    {
      text: i18n.t("Order.originFlgs.wechat_applet"),
      value: "103",
    },
    {
      text: i18n.t("Order.originFlgs.agent_android"),
      value: "201",
    },
    {
      text: i18n.t("Order.originFlgs.jcnAPP"),
      value: "105",
    },
    {
      text: i18n.t("Order.originFlgs.api2_shop", [shopName()]),
      value: "301",
    },
    {
      text: i18n.t("Order.originFlgs.api2_buyer"),
      value: "302",
    },
    {
      text: i18n.t("Order.originFlgs.weimob"),
      value: "401",
    },
    {
      text: i18n.t("Order.originFlgs.excel_buyer_import"),
      value: "402",
    },
    {
      text: i18n.t("Order.originFlgs.excel_import"),
      value: "003",
    },
    {
      text: i18n.t("Order.originFlgs.purchase"),
      value: "501",
    },
    {
      text: i18n.t("Order.originFlgs.adminOrder"),
      value: "502",
    },
    {
      text: i18n.t("Order.originFlgs.default"),
      value: "000",
    },
  ];
}
// 查找OriginFlgs
function orderOriginFlgsItem(value) {
  var item = orderOriginFlgs().find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Order.originFlgs.default"),
    value: "000",
  };
}
function orderOriginFlgsText(value) {
  return orderOriginFlgsItem(value).text;
}
Vue.filter('orderOriginFlgsText', orderOriginFlgsText);
function orderOriginFlgsColor() {
  return "";
}
Vue.filter('orderOriginFlgsColor', orderOriginFlgsColor);
function orderOriginFlgsTextColor() {
  return "";
}
Vue.filter('orderOriginFlgsTextColor', orderOriginFlgsTextColor);

//报价单状态
var quotationStatus = [
  {
    text: i18n.t("Quotations.status.wait_confirm"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Quotations.status.wait_approve"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Quotations.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
]
function quotationStatusItem(value) {
  var item = quotationStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function quotationStatusText(value) {
  return quotationStatusItem(value).text;
}
Vue.filter('quotationStatusText', quotationStatusText);
function quotationStatusColor(value) {
  return quotationStatusItem(value).color;
}
Vue.filter('quotationStatusColor', quotationStatusColor);
function quotationStatusTextColor(value) {
  return quotationStatusItem(value).textColor;
}
Vue.filter('quotationStatusTextColor', quotationStatusTextColor);

//报价单疑议状态
var quotationQuestionFlgs = [
  {
    text: i18n.t("Quotations.questionFlgs.yes"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Quotations.questionFlgs.no"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
]
function quotationQuestionFlgsItem(value) {
  var item = quotationQuestionFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function quotationQuestionFlgsText(value) {
  return quotationQuestionFlgsItem(value).text;
}
Vue.filter('quotationQuestionFlgsText', quotationQuestionFlgsText);
function quotationQuestionFlgsColor(value) {
  return quotationQuestionFlgsItem(value).color;
}
Vue.filter('quotationQuestionFlgsColor', quotationQuestionFlgsColor);
function quotationQuestionFlgsTextColor(value) {
  return quotationQuestionFlgsItem(value).textColor;
}
Vue.filter('quotationQuestionFlgsTextColor', quotationQuestionFlgsTextColor);

//报价单详情商品是否采用
var quotationUseFlgs = [
  {
    text: i18n.t("Quotations.useFlgs.yes"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Quotations.useFlgs.no"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
]
function quotationUseFlgsItem(value) {
  var item = quotationUseFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function quotationUseFlgsText(value) {
  return quotationUseFlgsItem(value).text;
}
Vue.filter('quotationUseFlgsText', quotationUseFlgsText);
function quotationUseFlgsColor(value) {
  return quotationUseFlgsItem(value).color;
}
Vue.filter('quotationUseFlgsColor', quotationUseFlgsColor);
function quotationUseFlgsTextColor(value) {
  return quotationUseFlgsItem(value).textColor;
}
Vue.filter('quotationUseFlgsTextColor', quotationUseFlgsTextColor);

//定价单状态
var economyStatus = [
  {
    text: i18n.t("Economies.status.wait_economy"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Economies.status.economied"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Economies.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
]
function economyStatusItem(value) {
  var item = economyStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function economyStatusText(value) {
  return economyStatusItem(value).text;
}
Vue.filter('economyStatusText', economyStatusText);
function economyStatusColor(value) {
  return economyStatusItem(value).color;
}
Vue.filter('economyStatusColor', economyStatusColor);
function economyStatusTextColor(value) {
  return economyStatusItem(value).textColor;
}
Vue.filter('economyStatusTextColor', economyStatusTextColor);

//采购计划单状态
var purchasePlansStatus = [
  {
    text: i18n.t("PurchasePlans.status.undistributed"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("PurchasePlans.status.distributed"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
]
function purchasePlansStatusItem(value) {
  var item = purchasePlansStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function purchasePlansStatusText(value) {
  return purchasePlansStatusItem(value).text;
}
Vue.filter('purchasePlansStatusText', purchasePlansStatusText);
function purchasePlansStatusColor(value) {
  return purchasePlansStatusItem(value).color;
}
Vue.filter('purchasePlansStatusColor', purchasePlansStatusColor);
function purchasePlansStatusTextColor(value) {
  return purchasePlansStatusItem(value).textColor;
}
Vue.filter('purchasePlansStatusTextColor', purchasePlansStatusTextColor);

//采购任务单状态
var purchaseTasksStatus = [
  {
    text: i18n.t("PurchaseTasks.status.unfinished"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("PurchaseTasks.status.finished"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
]
function purchaseTasksStatusItem(value) {
  var item = purchaseTasksStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function purchaseTasksStatusText(value) {
  return purchaseTasksStatusItem(value).text;
}
Vue.filter('purchaseTasksStatusText', purchaseTasksStatusText);
function purchaseTasksStatusColor(value) {
  return purchaseTasksStatusItem(value).color;
}
Vue.filter('purchaseTasksStatusColor', purchaseTasksStatusColor);
function purchaseTasksStatusTextColor(value) {
  return purchaseTasksStatusItem(value).textColor;
}
Vue.filter('purchaseTasksStatusTextColor', purchaseTasksStatusTextColor);

// 退货单状态
var returnOrderStatus = [
  {
    text: i18n.t("ReturnOrder.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Order.status.confirmed"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReturnOrder.status.granted"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("ReturnOrder.status.finished"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
// 查找Status
function returnOrderStatusItem(value) {
  var item = returnOrderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnOrderStatusText(value) {
  return returnOrderStatusItem(value).text;
}
Vue.filter('returnOrderStatusText', returnOrderStatusText);
function returnOrderStatusColor(value) {
  return returnOrderStatusItem(value).color;
}
Vue.filter('returnOrderStatusColor', returnOrderStatusColor);
function returnOrderStatusTextColor(value) {
  return returnOrderStatusItem(value).textColor;
}
Vue.filter('returnOrderStatusTextColor', returnOrderStatusTextColor);

// 采购退货单状态
var returnPurchaseStatus = [
  {
    text: i18n.t("returnPurchase.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("returnPurchase.status.confirmed"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("returnPurchase.status.granted"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("returnPurchase.status.finished"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
// 查找Status
function returnPurchaseStatusItem(value) {
  var item = returnPurchaseStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnPurchaseStatusText(value) {
  return returnPurchaseStatusItem(value).text;
}
Vue.filter('returnPurchaseStatusText', returnPurchaseStatusText);
function returnPurchaseStatusColor(value) {
  return returnPurchaseStatusItem(value).color;
}
Vue.filter('returnPurchaseStatusColor', returnPurchaseStatusColor);
function returnPurchaseStatusTextColor(value) {
  return returnPurchaseStatusItem(value).textColor;
}
Vue.filter('returnPurchaseStatusTextColor', returnPurchaseStatusTextColor);

// 退货单类型
var returnOrderTypes = [
  {
    text: i18n.t("ReturnOrder.Type.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReturnOrder.Type.off"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReturnOrder.Type.both"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Types
function returnOrderTypesItem(value) {
  var item = returnOrderTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnOrderTypesText(value) {
  return returnOrderTypesItem(value).text;
}
Vue.filter('returnOrderTypesText', returnOrderTypesText);
function returnOrderTypesColor(value) {
  return returnOrderTypesItem(value).color;
}
Vue.filter('returnOrderTypesColor', returnOrderTypesColor);
function returnOrderTypesTextColor(value) {
  return returnOrderTypesItem(value).textColor;
}
Vue.filter('returnOrderTypesTextColor', returnOrderTypesTextColor);

// 退货单类型
var returnPurchaseTypes = [
  {
    text: i18n.t("ReturnOrder.Type.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReturnOrder.Type.off"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  // {
  //   text: i18n.t("ReturnOrder.Type.both"),
  //   color: "primary",
  //   textColor: "white",
  //   value: 3,
  // },
];
// 查找Types
function returnPurchaseTypesItem(value) {
  var item = returnPurchaseTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnPurchaseTypesText(value) {
  return returnPurchaseTypesItem(value).text;
}
Vue.filter('returnPurchaseTypesText', returnPurchaseTypesText);
function returnPurchaseTypesColor(value) {
  return returnPurchaseTypesItem(value).color;
}
Vue.filter('returnPurchaseTypesColor', returnPurchaseTypesColor);
function returnPurchaseTypesTextColor(value) {
  return returnPurchaseTypesItem(value).textColor;
}
Vue.filter('returnPurchaseTypesTextColor', returnPurchaseTypesTextColor);

// 退货单来源 1后台、2门店
var returnOriginFlgs = [
  {
    text: i18n.t("ReturnOrder.Origin.admin"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReturnOrder.Origin.shop"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReturnOrder.Origin.ent"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Types
function returnOriginFlgsItem(value) {
  var item = returnOriginFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnOriginFlgsText(value) {
  return returnOriginFlgsItem(value).text;
}
Vue.filter('returnOriginFlgsText', returnOriginFlgsText);
function returnOriginFlgsColor(value) {
  return returnOriginFlgsItem(value).color;
}
Vue.filter('returnOriginFlgsColor', returnOriginFlgsColor);
function returnOriginFlgsTextColor(value) {
  return returnOriginFlgsItem(value).textColor;
}
Vue.filter('returnOriginFlgsTextColor', returnOriginFlgsTextColor);

//退框状态 ,待归还1，部分归还2，已归还3
var returnBasketStatus = [
  {
    text: i18n.t("ReturnBasket.status.wait_complete"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReturnBasket.status.part_complete"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReturnBasket.status.complete"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Status
function returnBasketStatusItem(value) {
  var item = returnBasketStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnBasketStatusText(value) {
  return returnBasketStatusItem(value).text;
}
Vue.filter('returnBasketStatusText', returnBasketStatusText);
function returnBasketStatusColor(value) {
  return returnBasketStatusItem(value).color;
}
Vue.filter('returnBasketStatusColor', returnBasketStatusColor);
function returnBasketStatusTextColor(value) {
  return returnBasketStatusItem(value).textColor;
}
Vue.filter('returnBasketStatusTextColor', returnBasketStatusTextColor);

var stockOrderINStatus = [
  {
    text: i18n.t("StockOrderIN.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockOrderIN.status.granted"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("StockOrderIN.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Stock Order Status
function stockOrderINStatusItem(value) {
  var item = stockOrderINStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderINStatusText(value) {
  return stockOrderINStatusItem(value).text;
}
Vue.filter('stockOrderINStatusText', stockOrderINStatusText);
function stockOrderINStatusColor(value) {
  return stockOrderINStatusItem(value).color;
}
Vue.filter('stockOrderINStatusColor', stockOrderINStatusColor);
function stockOrderINStatusTextColor(value) {
  return stockOrderINStatusItem(value).textColor;
}
Vue.filter('stockOrderINStatusTextColor', stockOrderINStatusTextColor);

// 查找入库类型
var stockOrderINTypes = [
  {
    text: i18n.t("StockOrderIN.types.return_order_in"),
    value: 1,
  },
  {
    text: i18n.t("StockOrderIN.types.requisition_in"),
    value: 2,
  },
  {
    text: i18n.t("StockOrderIN.types.stock_taking_in"),
    value: 3,
  },
  {
    text: i18n.t("StockOrderIN.types.production_in"),
    value: 4,
  },
  {
    text: i18n.t("StockOrderIN.types.normal_one_in"),
    value: 11,
  },
  {
    text: i18n.t("StockOrderIN.types.other_stock_in"),
    value: 12,
  },
  {
    text: i18n.t("StockOrderIN.types.overage_stock_in"),
    value: 13,
  },
  {
    text: i18n.t("StockOrderIN.types.init_stock_in"),
    value: 21,
  },
];
function stockOrderINTypesItem(value) {
  var item = stockOrderINTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function stockOrderINTypesText(value) {
  return stockOrderINTypesItem(value).text;
}
Vue.filter('stockOrderINTypesText', stockOrderINTypesText);
function stockOrderINTypesColor(value) {
  return stockOrderINTypesItem(value).color;
}
Vue.filter('stockOrderINTypesColor', stockOrderINTypesColor);
function stockOrderINTypesTextColor(value) {
  return stockOrderINTypesItem(value).textColor;
}
Vue.filter('stockOrderINTypesTextColor', stockOrderINTypesTextColor);


var stockOrderInShopTypes = [
  {
    text: i18n.t("StockOrderIN.types.return_order_in"),
    value: 1,
  },
  {
    text: i18n.t("StockOrderIN.types.examines_in"),
    value: 2,
  },
  {
    text: i18n.t("StockOrderIN.types.stock_taking_in"),
    value: 3,
  },
  {
    text: i18n.t("StockOrderIN.types.init_stock_in"),
    value: 5,
  },
  {
    text: i18n.t("StockOrderIN.types.requisition_in"),
    value: 6,
  },
  {
    text: i18n.t("StockOrderIN.types.normal_one_in"),
    value: 11,
  },
];
function stockOrderInShopTypesItem(value) {
  var item = stockOrderINTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderInShopTypesText(value) {
  return stockOrderInShopTypesItem(value).text;
}
Vue.filter('stockOrderInShopTypesText', stockOrderInShopTypesText);

var stockOrderOUTStatus = [
  {
    text: i18n.t("StockOrderOUT.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockOrderOUT.status.granted"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("StockOrderOUT.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Stock Order Status
function stockOrderOUTStatusItem(value) {
  var item = stockOrderOUTStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderOUTStatusText(value) {
  return stockOrderOUTStatusItem(value).text;
}
Vue.filter('stockOrderOUTStatusText', stockOrderOUTStatusText);
function stockOrderOUTStatusColor(value) {
  return stockOrderOUTStatusItem(value).color;
}
Vue.filter('stockOrderOUTStatusColor', stockOrderOUTStatusColor);
function stockOrderOUTStatusTextColor(value) {
  return vuetify.dark ? stockOrderOUTStatusItem(value).textColor : '';
}
Vue.filter('stockOrderOUTStatusTextColor', stockOrderOUTStatusTextColor);

var stockOrderSortingStatus = [
  {
    text: i18n.t("StockOrderOUT.PickingOut.sorting_status.unpicked"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("StockOrderOUT.PickingOut.sorting_status.partial"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockOrderOUT.PickingOut.sorting_status.full"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];
// 查找Stock Order Sorting Status
function stockOrderSortingStatusItem(value) {
  var item = stockOrderSortingStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderSortingStatusText(value) {
  return stockOrderSortingStatusItem(value).text;
}
Vue.filter('stockOrderSortingStatusText', stockOrderSortingStatusText);
function stockOrderSortingStatusColor(value) {
  return stockOrderSortingStatusItem(value).color;
}
Vue.filter('stockOrderSortingStatusColor', stockOrderSortingStatusColor);
function stockOrderSortingStatusTextColor(value) {
  return stockOrderSortingStatusItem(value).textColor;
}
Vue.filter('stockOrderSortingStatusTextColor', stockOrderSortingStatusTextColor);

var stockOrderOUTThirdStatus = [
  {
    text: i18n.t("StockOrderOUT.thirdStatus.creating"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockOrderOUT.thirdStatus.created"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("StockOrderOUT.thirdStatus.unsuccessful"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Stock Order Status
function stockOrderOUTThirdStatusItem(value) {
  var item = stockOrderOUTThirdStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderOUTThirdStatusText(value) {
  return stockOrderOUTThirdStatusItem(value).text;
}
Vue.filter('stockOrderOUTThirdStatusText', stockOrderOUTThirdStatusText);
function stockOrderOUTThirdStatusColor(value) {
  return stockOrderOUTThirdStatusItem(value).color;
}
Vue.filter('stockOrderOUTThirdStatusColor', stockOrderOUTThirdStatusColor);
function stockOrderOUTThirdStatusTextColor(value) {
  return vuetify.dark ? stockOrderOUTThirdStatusItem(value).textColor : '';
}
Vue.filter('stockOrderOUTThirdStatusTextColor', stockOrderOUTThirdStatusTextColor);

var stockOrderOUTTypes = [
  {
    text: i18n.t("StockOrderOUT.types.order"),
    value: 1,
  },
  {
    text: i18n.t("StockOrderOUT.types.requisition"),
    value: 2,
  },
  {
    text: i18n.t("StockOrderOUT.types.stock_taking"),
    value: 3,
  },
  {
    text: i18n.t("StockOrderOUT.types.production"),
    value: 4,
  },
  {
    text: i18n.t("StockOrderOUT.types.normal_one"),
    value: 11,
  },
  {
    text: i18n.t("StockOrderOUT.types.normal_two"),
    value: 12,
  },
  {
    text: i18n.t("StockOrderOUT.types.normal_three"),
    value: 13,
  },
  {
    text: i18n.t("StockOrderOUT.types.normal_four"),
    value: 14,
  },
  {
    text: i18n.t("StockOrderOUT.types.other_stock_out"),
    value: 15,
  },
  {
    text: i18n.t("StockOrderOUT.types.overage_stock_out"),
    value: 16,
  },
  {
    text: i18n.t("StockOrderOUT.types.return_purchase"),
    value: 17,
  },
];
function stockOrderOUTTypesItem(value) {
  var item = stockOrderOUTTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function stockOrderOUTTypesText(value) {
  return stockOrderOUTTypesItem(value).text;
}
Vue.filter('stockOrderOUTTypesText', stockOrderOUTTypesText);
function stockOrderOUTTypesColor(value) {
  return stockOrderOUTTypesItem(value).color;
}
Vue.filter('stockOrderOUTTypesColor', stockOrderOUTTypesColor);
function stockOrderOUTTypesTextColor(value) {
  return stockOrderOUTTypesItem(value).textColor;
}
Vue.filter('stockOrderOUTTypesTextColor', stockOrderOUTTypesTextColor);

//查找出库类型
var stockOrderOutShopTypes = [
  {
    text: i18n.t("StockOrderOUT.types.order"),
    value: 1,
  },
  {
    text: i18n.t("StockOrderOUT.types.requisition"),
    value: 2,
  },
  {
    text: i18n.t("StockOrderOUT.types.stock_taking"),
    value: 3,
  },
  {
    text: i18n.t("StockOrderOUT.types.normal_two"),
    value: 12,
  },
  {
    text: i18n.t("StockOrderOUT.types.normal_one"),
    value: 11,
  },
  {
    text: i18n.t("StockOrderOUT.types.return"),
    value: 13,
  },
  {
    text: i18n.t("StockOrderOUT.types.other_stock_out"),
    value: 14,
  },
];
function stockOrderOutShopTypesItem(value) {
  var item = stockOrderOutShopTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function stockOrderOutShopTypesText(value) {
  return stockOrderOutShopTypesItem(value).text;
}
Vue.filter('stockOrderOutShopTypesText', stockOrderOutShopTypesText);

var stockOrderOUTBrokenType = [
  {
    text: i18n.t("StockOrderOUT.brokenTypes.program"),
    value: 1,
  },
  {
    text: i18n.t("StockOrderOUT.brokenTypes.production"),
    value: 2,
  },
  {
    text: i18n.t("StockOrderOUT.brokenTypes.marketing"),
    value: 3,
  },
  {
    text: i18n.t("StockOrderOUT.brokenTypes.other"),
    value: 4,
  },
  {
    text: i18n.t("StockOrderOUT.brokenTypes.requisition"),
    value: 5,
  },
];
function stockOrderOUTBrokenTypeItem(value) {
  var item = stockOrderOUTBrokenType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderOUTBrokenTypeText(value) {
  return stockOrderOUTBrokenTypeItem(value).text;
}
Vue.filter('stockOrderOUTBrokenTypeText', stockOrderOUTBrokenTypeText);

// 页面是否打印搜索
var stockOrderOUTPrintStatus = [
  {
    text: i18n.t("StockOrderOUT.is_print.on"),
    color: "action",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockOrderOUT.is_print.off"),
    color: "action",
    textColor: "white",
    value: 0,
  }
];

//波次策略
//策略类型
var pickOrderTypes = [
  {
    text: i18n.t("WaveRules.pickOrderTypes.pick_order_type_one"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("WaveRules.pickOrderTypes.pick_order_type_two"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("WaveRules.pickOrderTypes.pick_order_type_three"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("WaveRules.pickOrderTypes.pick_order_type_four"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("WaveRules.pickOrderTypes.pick_order_type_five"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
];
// 查找pickOrderTypes
function pickOrderTypesItem(value) {
  var item = pickOrderTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function pickOrderTypesText(value) {
  return pickOrderTypesItem(value).text;
}
Vue.filter('pickOrderTypesText', pickOrderTypesText);
function pickOrderTypesColor(value) {
  return pickOrderTypesItem(value).color;
}
Vue.filter('pickOrderTypesColor', pickOrderTypesColor);
function pickOrderTypesTextColor(value) {
  return pickOrderTypesItem(value).textColor;
}
Vue.filter('pickOrderTypesTextColor', pickOrderTypesTextColor);
//拣选类型
var pickOrderWays = [
  {
    text: i18n.t("WaveRules.pickOrderWays.sort_after_pick_PDA"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("WaveRules.pickOrderWays.sort_after_pick_paper"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("WaveRules.pickOrderWays.sort_after_pick_PC"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("WaveRules.pickOrderWays.sort_while_picking_paper"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("WaveRules.pickOrderWays.sort_while_picking_PDA"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
];
// 查找pickOrderWays
function pickOrderWaysItem(value) {
  var item = pickOrderWays.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function pickOrderWaysText(value) {
  return pickOrderWaysItem(value).text;
}
Vue.filter('pickOrderWaysText', pickOrderWaysText);
function pickOrderWaysColor(value) {
  return pickOrderWaysItem(value).color;
}
Vue.filter('pickOrderWaysColor', pickOrderWaysColor);
function pickOrderWaysTextColor(value) {
  return pickOrderWaysItem(value).textColor;
}
Vue.filter('pickOrderWaysTextColor', pickOrderWaysTextColor);
//拆分规则
var areaSplitRulers = [
  {
    text: i18n.t("WaveRules.areaSplitRulers.area_split_on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("WaveRules.areaSplitRulers.area_split_off"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];
// 查找areaSplitRulers
function areaSplitRulersItem(value) {
  var item = areaSplitRulers.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function areaSplitRulersText(value) {
  return areaSplitRulersItem(value).text;
}
Vue.filter('areaSplitRulersText', areaSplitRulersText);
function areaSplitRulersColor(value) {
  return areaSplitRulersItem(value).color;
}
Vue.filter('areaSplitRulersColor', areaSplitRulersColor);
function areaSplitRulersTextColor(value) {
  return areaSplitRulersItem(value).textColor;
}
Vue.filter('areaSplitRulersTextColor', areaSplitRulersTextColor);
//策略状态
var waveRulerStatus = [
  {
    text: i18n.t("WaveRules.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("WaveRules.status.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  },
];
// 查找waveRulerStatus
function waveRulerStatusItem(value) {
  var item = waveRulerStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function waveRulerStatusText(value) {
  return waveRulerStatusItem(value).text;
}
Vue.filter('waveRulerStatusText', waveRulerStatusText);
function waveRulerStatusColor(value) {
  return waveRulerStatusItem(value).color;
}
Vue.filter('waveRulerStatusColor', waveRulerStatusColor);
function waveRulerStatusTextColor(value) {
  return waveRulerStatusItem(value).textColor;
}
Vue.filter('waveRulerStatusTextColor', waveRulerStatusTextColor);

//波次状态
var waveStatus = [
  {
    text: i18n.t("Wave.status.waitPick"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Wave.status.picking"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Wave.status.waitSorting"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Wave.status.picked"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
// 查找Wave Status
function waveStatusItem(value) {
  var item = waveStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function waveStatusText(value) {
  return waveStatusItem(value).text;
}
Vue.filter('waveStatusText', waveStatusText);
function waveStatusColor(value) {
  return waveStatusItem(value).color;
}
Vue.filter('waveStatusColor', waveStatusColor);
function waveStatusTextColor(value) {
  return waveStatusItem(value).textColor;
}
Vue.filter('waveStatusTextColor', waveStatusTextColor);

// 是否重量单位
var weightFlgs = [
  {
    text: i18n.t("Units.weightFlg.yes"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Units.weightFlg.no"),
    color: "gray",
    textColor: "white",
    value: 0,
  }
];
function weightFlgsItem(value) {
  var item = weightFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function weightFlgsText(value) {
  return weightFlgsItem(value).text
}
Vue.filter('weightFlgsText', weightFlgsText);
function weightFlgsColor(value) {
  return weightFlgsItem(value).color;
}
Vue.filter('weightFlgsColor', weightFlgsColor);
function weightFlgsTextColor(value) {
  return weightFlgsItem(value).textColor;
}
Vue.filter('weightFlgsTextColor', weightFlgsTextColor)
// 是否可用于净含量
var netFlgs = [
  {
    text: i18n.t("Units.netFlg.yes"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Units.netFlg.no"),
    color: "gray",
    textColor: "white",
    value: 0,
  }
];
function netFlgsItem(value) {
  var item = netFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function netFlgsText(value) {
  return netFlgsItem(value).text
}
Vue.filter('netFlgsText', netFlgsText);
function netFlgsColor(value) {
  return netFlgsItem(value).color;
}
Vue.filter('netFlgsColor', netFlgsColor);
function netFlgsTextColor(value) {
  return netFlgsItem(value).textColor;
}
Vue.filter('netFlgsTextColor', netFlgsTextColor)

// 出/入库类型
var outInFlgs = [
  {
    text: i18n.t("inOutDetail.type.out"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("inOutDetail.type.in"),
    color: "primary",
    textColor: "white",
    value: 2,
  }
];
// 查找
function outInFlgsItem(value) {
  var item = outInFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function outInFlgsText(value) {
  return outInFlgsItem(value).text;
}
Vue.filter('outInFlgsText', outInFlgsText);
function outInFlgsColor(value) {
  return outInFlgsItem(value).color;
}
Vue.filter('outInFlgsColor', outInFlgsColor);
function outInFlgsTextColor(value) {
  return outInFlgsItem(value).textColor;
}
Vue.filter('outInFlgsTextColor', outInFlgsTextColor)


var distributionStatus = [
  {
    text: i18n.t("Distribution.status.out_stock"),
    color: "action",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Distribution.status.distributing"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Distribution.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];


// 查找Distribution Status
function distributionStatusItem(value) {
  var item = distributionStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function distributionStatusText(value) {
  return distributionStatusItem(value).text;
}
Vue.filter('distributionStatusText', distributionStatusText);
function distributionStatusColor(value) {
  return distributionStatusItem(value).color;
}
Vue.filter('distributionStatusColor', distributionStatusColor);
function distributionStatusTextColor(value) {
  return distributionStatusItem(value).textColor;
}
Vue.filter('distributionStatusTextColor', distributionStatusTextColor);

// 页面是否打印搜索
var distributionPrintStatus = [
  {
    text: i18n.t("Distribution.is_print.print_no"),
    color: "action",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Distribution.is_print.print_yes"),
    color: "action",
    textColor: "white",
    value: 1,
  }
];


var examineStatus = [
  {
    text: i18n.t("Examine.status.distributed"),
    color: "accent",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.status.finished"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找Examine Status
function examineStatusItem(value) {
  var item = examineStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineStatusText(value) {
  return examineStatusItem(value).text;
}
Vue.filter('examineStatusText', examineStatusText);
function examineStatusColor(value) {
  return examineStatusItem(value).color;
}
Vue.filter('examineStatusColor', examineStatusColor);
function examineStatusTextColor(value) {
  return examineStatusItem(value).textColor;
}
Vue.filter('examineStatusTextColor', examineStatusTextColor);

// 查找Examine Flgs
var examineFlgs = [
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_wait"),
    color: "accent",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_shop"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_account"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_system"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_agent"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
function examineFlgsItem(value) {
  var item = examineFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineFlgsText(value) {
  return examineFlgsItem(value).text;
}
Vue.filter('examineFlgsText', examineFlgsText);
function examineFlgsColor(value) {
  return examineFlgsItem(value).color;
}
Vue.filter('examineFlgsColor', examineFlgsColor);
function examineFlgsTextColor(value) {
  return examineFlgsItem(value).textColor;
}
Vue.filter('examineFlgsTextColor', examineFlgsTextColor);

// 查找Examine AbnormalFlgs
var examineAbnormalFlgs = [
  {
    text: i18n.t("Examine.abnormalFlgs.normal"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
];
function examineAbnormalFlgsItem(value) {
  var item = examineAbnormalFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineAbnormalFlgsText(value) {
  return examineAbnormalFlgsItem(value).text;
}
Vue.filter('examineAbnormalFlgsText', examineAbnormalFlgsText);
function examineAbnormalFlgsColor(value) {
  return examineAbnormalFlgsItem(value).color;
}
Vue.filter('examineAbnormalFlgsColor', examineAbnormalFlgsColor);
function examineAbnormalFlgsTextColor(value) {
  return examineAbnormalFlgsItem(value).textColor;
}
Vue.filter('examineAbnormalFlgsTextColor', examineAbnormalFlgsTextColor);

// 查找Examine AbnormalFlgs,异常处理状态
var examineIsAbnormaled = [
  {
    text: i18n.t("Examine.abnormalFlgs.normal"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal_untreaded"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal_handeld"),
    color: "accent",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal_complete"),
    color: "accent",
    textColor: "white",
    value: 3,
  },
];
function examineIsAbnormaledItem(value) {
  var item = examineIsAbnormaled.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineIsAbnormaledText(value) {
  return examineIsAbnormaledItem(value).text;
}
Vue.filter('examineIsAbnormaledText', examineIsAbnormaledText);
function examineIsAbnormaledColor(value) {
  return examineIsAbnormaledItem(value).color;
}
Vue.filter('examineIsAbnormaledColor', examineIsAbnormaledColor);
function examineIsAbnormaledTextColor(value) {
  return examineIsAbnormaledItem(value).textColor;
}
Vue.filter('examineIsAbnormaledTextColor', examineIsAbnormaledTextColor);

var billStatus = [
  {
    text: i18n.t("Bill.status.new"),
    color: "gray",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Bill.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Bill Status
function billStatusItem(value) {
  var item = billStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billStatusText(value) {
  return billStatusItem(value).text;
}
Vue.filter('billStatusText', billStatusText);
function billStatusColor(value) {
  return billStatusItem(value).color;
}
Vue.filter('billStatusColor', billStatusColor);
function billStatusTextColor(value) {
  return billStatusItem(value).textColor;
}
Vue.filter('billStatusTextColor', billStatusTextColor);

// 冻结状态
var prohibitFlgs = [
  {
    text: i18n.t("StockDetails.prohibit_flg.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("StockDetails.prohibit_flg.off"),
    color: "danger",
    textColor: "white",
    value: 1
  }
];
// 查找prohibitFlgs
function prohibitFlgsItem(value) {
  var item = prohibitFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function prohibitFlgsText(value) {
  return prohibitFlgsItem(value).text;
}
Vue.filter('prohibitFlgsText', prohibitFlgsText)
function prohibitFlgsColor(value) {
  return prohibitFlgsItem(value).color;
}
Vue.filter('prohibitFlgsColor', prohibitFlgsColor);
function prohibitFlgsTextColor(value) {
  return prohibitFlgsItem(value).textColor
}
Vue.filter('prohibitFlgsTextColor', prohibitFlgsTextColor)
// 过期状态
var expiredFlgs = [
  {
    text: i18n.t("StockDetails.expired_status.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("StockDetails.expired_status.off"),
    color: "danger",
    textColor: "white",
    value: 1
  }
];
function expiredFlgsItem(value) {
  var item = expiredFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function expiredFlgsText(value) {
  return expiredFlgsItem(value).text;
}
Vue.filter('expiredFlgsText', expiredFlgsText)
function expiredFlgsColor(value) {
  return expiredFlgsItem(value).color
}
Vue.filter('expiredFlgsColor', expiredFlgsColor)
function expiredFlgsTextColor(value) {
  return expiredFlgsItem(value).textColor
}
Vue.filter('expiredFlgsTextColor', expiredFlgsTextColor)
// 使用状态
var useStatus = [
  {
    text: i18n.t("StockDetails.use_status.off"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("StockDetails.use_status.on_off"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("StockDetails.use_status.on"),
    color: "",
    textColor: "",
    value: 1
  }
]
// 查找UseStatus
function useStatusItem(value) {
  var item = useStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function useStatusText(value) {
  return useStatusItem(value).text;
}
Vue.filter('useStatusText', useStatusText)
function useStatusColor(value) {
  return useStatusItem(value).color
}
Vue.filter('useStatusColor', useStatusColor)
function useStatusTextColor(value) {
  return useStatusItem(value).textColor
}
Vue.filter('useStatusTextColor', useStatusTextColor)

// 应收应付历史-要货商供应商
var billObjType = [
  {
    text: i18n.t("billRecords.Fields.importers"),
    color: "info",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("billRecords.Fields.supplier"),
    color: "warning",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("billRecords.Fields.stock"),
    color: "primary",
    textColor: "white",
    value: 3,
  }
]
function billObjTypeItem(value) {
  var item = billObjType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billObjTypeText(value) {
  return billObjTypeItem(value).text;
}
Vue.filter('billObjTypeText', billObjTypeText);
function billObjTypeColor(value) {
  return billObjTypeItem(value).color;
}
Vue.filter('billObjTypeColor', billObjTypeColor);
function billObjTypeTextColor(value) {
  return billObjTypeItem(value).textColor;
}
Vue.filter('billObjTypeTextColor', billObjTypeTextColor);

// 对象类型
function objType() {
  return [
    {
      text: i18n.t("ReceiptBillAnalyze.objType.importers", [shopName()]),
      color: "primary",
      textColor: "white",
      value: 1,
    },
    {
      text: i18n.t("ReceiptBillAnalyze.objType.supplier"),
      color: "primary",
      textColor: "white",
      value: 2,
    },
    {
      text: i18n.t("ReceiptBillAnalyze.objType.stock"),
      color: "primary",
      textColor: "white",
      value: 3,
    }
  ]
}
function objTypeItem(value) {
  var item = objType().find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function objTypeText(value) {
  return objTypeItem(value).text;
}
Vue.filter('objTypeText', objTypeText);
function objTypeColor(value) {
  return objTypeItem(value).color;
}
Vue.filter('objTypeColor', objTypeColor);
function objTypeTextColor(value) {
  return objTypeItem(value).textColor;
}
Vue.filter('objTypeTextColor', objTypeTextColor);

// 对账单类型（要货对账单，门店退货对账单）
var billTypes = [
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypeShop"),
    color: "primary",
    textColor: "white",
    value: 101,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypeReturn"),
    color: "primary",
    textColor: "white",
    value: 102,
  }
]
function billTypesItem(value) {
  var item = billTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billTypesText(value) {
  return billTypesItem(value).text;
}
Vue.filter('billTypesText', billTypesText);
function billTypesColor(value) {
  return billTypesItem(value).color;
}
Vue.filter('billTypesColor', billTypesColor);
function billTypesTextColor(value) {
  return billTypesItem(value).textColor;
}
Vue.filter('billTypesTextColor', billTypesTextColor);

// 对账单类型（采购对账单，采购退货对账单）
var purchaseBillTypes = [
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypePurchase"),
    color: "primary",
    textColor: "white",
    value: 201,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypePurchaseReturn"),
    color: "primary",
    textColor: "white",
    value: 202,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.purchaseReturn"),
    color: "primary",
    textColor: "white",
    value: 203,
  }
]

// 对账单类型（调拨应收，调拨应付）
var stockBillTypes = [
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.requisition"),
    color: "primary",
    textColor: "white",
    value: 301,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.requisitionPay"),
    color: "primary",
    textColor: "white",
    value: 302,
  }
]

// 对账单类型
var BillTypes = [
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypeShop"),
    color: "primary",
    textColor: "white",
    value: 101,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypeReturn"),
    color: "primary",
    textColor: "white",
    value: 102,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypePurchase"),
    color: "primary",
    textColor: "white",
    value: 201,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypePurchaseReturn"),
    color: "primary",
    textColor: "white",
    value: 202,
  }
]
// 对账状态
var billCheckFlg = [
  {
    text: i18n.t("ReceiptBillAnalyze.billCheckFlg.new"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billCheckFlg.finished"),
    color: "primary",
    textColor: "white",
    value: 1,
  }
]
function billCheckFlgItem(value) {
  var item = billCheckFlg.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billCheckFlgText(value) {
  return billCheckFlgItem(value).text;
}
Vue.filter('billCheckFlgText', billCheckFlgText);
function billCheckFlgColor(value) {
  return billCheckFlgItem(value).color;
}
Vue.filter('billCheckFlgColor', billCheckFlgColor);
function billCheckFlgTextColor(value) {
  return billCheckFlgItem(value).textColor;
}
Vue.filter('billCheckFlgTextColor', billCheckFlgTextColor);
// receipt/detail --追加-
var payTypeArr = [
  {
    text: i18n.t("ReceiptDetail.payTypeArr.balance"),
    value: 101,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.wechat"),
    value: 102,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.alipay"),
    value: 103,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.bank"),
    value: 201,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.cash"),
    value: 202,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.esun"),
    value: 215,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.make_money"),
    value: 217,
  },
]

// receipt  --归账--支付方式   收款
var payTypeReceipt = [
  {
    text: i18n.t("ReceiptDetail.payTypeArr.wechat"),
    value: 102,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.alipay"),
    value: 103,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.bank"),
    value: 201,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.cash"),
    value: 202,
  },
]

// receipt  收款付款 101 102 bill_type
var billTypeReceipt = [
  {
    text: i18n.t("ReceiptDetail.payTypeArr.balance"),
    value: 101,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.wechat"),
    value: 102,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.alipay"),
    value: 103,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.bank"),
    value: 201,
  },
  {
    text: i18n.t("ReceiptDetail.payTypeArr.cash"),
    value: 202,
  },
]

// 到账时间
var  lklCcashType= [
  {
    text: i18n.t("SubAccount.lklCash.D0"),
    value: "D0",
  },
  {
    text: i18n.t("SubAccount.lklCash.D1"),
    value: "D1",
  },
  {
    text: i18n.t("SubAccount.lklCash.T1"),
    value: "T1",
  },
]

// 提现方式
var cashType = [
  {
    text: i18n.t("SubAccount.hfCash.hfCashType_one"),
    value: 1,
  },
]

// 绑卡类型
var cardtype = [
  {
    text: i18n.t("SubAccount.hfCash.card_type_one"),
    value: 1,
  },
]

// 退款
var operationType = [
  {
    text: i18n.t("ReceiptDetail.operation_type"),
    color: "action",
    textColor: "white",
    value: 203,
  },
  {
    text: i18n.t("ReceiptDetail.reverse"),
    color: "danger",
    textColor: "white",
    value: 901,
  },
]
function operationTypeItem(value) {
  var item = operationType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function operationTypeText(value) {
  return operationTypeItem(value).text;
}
Vue.filter('operationTypeText', operationTypeText);
function operationTypeColor(value) {
  return operationTypeItem(value).color;
}
Vue.filter('operationTypeColor', operationTypeColor);
function operationTypeTextColor(value) {
  return operationTypeItem(value).textColor;
}
Vue.filter('operationTypeTextColor', operationTypeTextColor);

// 归账状态
var billFlgs = [
  {
    text: i18n.t("ReceiptBillAnalyze.billStatus.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billStatus.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  }
]
function billFlgsItem(value) {
  var item = billFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billFlgsText(value) {
  return billFlgsItem(value).text;
}
Vue.filter('billFlgsText', billFlgsText);
function billFlgsColor(value) {
  return billFlgsItem(value).color;
}
Vue.filter('billFlgsColor', billFlgsColor);
function billFlgsTextColor(value) {
  return billFlgsItem(value).textColor;
}
Vue.filter('billFlgsTextColor', billFlgsTextColor);

// 批量收付款-财务状态
var financeStatus = [
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.unpay"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.pay_apart"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];
function financeStatusItem(value) {
  var item = financeStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function financeStatusText(value) {
  return financeStatusItem(value).text;
}
Vue.filter('financeStatusText', financeStatusText);
function financeStatusColor(value) {
  return financeStatusItem(value).color;
}
Vue.filter('financeStatusColor', financeStatusColor);
function financeStatusTextColor(value) {
  return financeStatusItem(value).textColor;
}
Vue.filter('financeStatusTextColor', financeStatusTextColor);

// 财务状态
var financeFlgs = [
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.unpay"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.pay_apart"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.paid"),
    color: "primary",
    textColor: "white",
    value: 3,
  }
];
function financeFlgsItem(value) {
  var item = financeFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function financeFlgsText(value) {
  return financeFlgsItem(value).text;
}
Vue.filter('financeFlgsText', financeFlgsText);
function financeFlgsColor(value) {
  return financeFlgsItem(value).color;
}
Vue.filter('financeFlgsColor', financeFlgsColor);
function financeFlgsTextColor(value) {
  return financeFlgsItem(value).textColor;
}
Vue.filter('financeFlgsTextColor', financeFlgsTextColor);

var billPayFlgs = [
  {
    text: i18n.t("Bill.payFlgs.unpay"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Bill.payFlgs.pay_apart"),
    color: "accent",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Bill.payFlgs.paid"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找PayFlgs
function billPayFlgsItem(value) {
  var item = billPayFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billPayFlgsText(value) {
  return billPayFlgsItem(value).text;
}
Vue.filter('billPayFlgsText', billPayFlgsText);
function billPayFlgsColor(value) {
  return billPayFlgsItem(value).color;
}
Vue.filter('billPayFlgsColor', billPayFlgsColor);
function billPayFlgsTextColor(value) {
  return billPayFlgsItem(value).textColor;
}
Vue.filter('billPayFlgsTextColor', billPayFlgsTextColor);

// 财务对账单-检索类型-对账单类型
var financeBillType = [
  {
    text: i18n.t("financeBills.billTypes.billTypeShop"),
    value: 101,
  },
  {
    text: i18n.t("financeBills.billTypes.billTypePurchase"),
    value: 201,
  },
];

//销售状态
var alliancesStatus = [
  {
    text: i18n.t("Alliances.status.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Alliances.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找alliancesStatus
function alliancesStatusItem(value) {
  var item = alliancesStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function alliancesStatusText(value) {
  return alliancesStatusItem(value).text;
}
Vue.filter('alliancesStatusText', alliancesStatusText);
function alliancesStatusColor(value) {
  return alliancesStatusItem(value).color;
}
Vue.filter('alliancesStatusColor', alliancesStatusColor);
function alliancesStatusTextColor(value) {
  return alliancesStatusItem(value).textColor;
}
Vue.filter('alliancesStatusTextColor', alliancesStatusTextColor);

//汇付状态
var huifuStatus = [
  {
    text: i18n.t("HuifuAccount.status.off"),
    color: "grey",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("HuifuAccount.status.on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
];
// 查找汇付状态
function huifuStatusItem(value) {
  var item = huifuStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function huifuStatusText(value) {
  return huifuStatusItem(value).text;
}
Vue.filter('huifuStatusText', huifuStatusText);
function huifuStatusColor(value) {
  return huifuStatusItem(value).color;
}
Vue.filter('huifuStatusColor', huifuStatusColor);
function huifuStatusTextColor(value) {
  return huifuStatusItem(value).textColor;
}
Vue.filter('huifuStatusTextColor', huifuStatusTextColor);

// 汇付法人证件类型
var legal_cert_type = [
  {
    text: i18n.t("HuifuAccount.legalCertType.00"),
    value: '00',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.01"),
    value: '01',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.02"),
    value: '02',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.03"),
    value: '03',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.04"),
    value: '04',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.05"),
    value: '05',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.06"),
    value: '06',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.07"),
    value: '07',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.08"),
    value: '08',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.09"),
    value: '09',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.10"),
    value: '10',
  },
  {
    text: i18n.t("HuifuAccount.legalCertType.11"),
    value: '11',
  }
];
// 查找汇付法人证件类型
function legalCertTypeItem(value) {
  var item = legal_cert_type.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    value: ""
  };
}
function legalCertTypeText(value) {
  return legalCertTypeItem(value).text;
}
Vue.filter('legalCertTypeText', legalCertTypeText);

// 汇付入驻结算账户类型
var huifuCardType = [
  {
    text: i18n.t("HuifuAccount.cardType.public"),
    value: 0,
  },
  {
    text: i18n.t("HuifuAccount.cardType.private"),
    value: 1,
  },
];
// 查找汇付状态
function huifuCardTypeItem(value) {
  var item = huifuCardType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function huifuCardTypeText(value) {
  return huifuCardTypeItem(value).text;
}
Vue.filter('huifuCardTypeText', huifuCardTypeText);

//汇付支付类型
var huifuIoType = [
  {
    text: i18n.t("HuifuAccount.ioType.payment"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("HuifuAccount.ioType.refunds"),
    color: "action",
    textColor: "white",
    value: 2,
  }
];
// 查找汇付状态
function huifuIoTypeItem(value) {
  var item = huifuIoType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function huifuIoTypeText(value) {
  return huifuIoTypeItem(value).text;
}
Vue.filter('huifuIoTypeText', huifuIoTypeText);
function huifuIoTypeColor(value) {
  return huifuIoTypeItem(value).color;
}
Vue.filter('huifuIoTypeColor', huifuIoTypeColor);
function huifuIoTypeTextColor(value) {
  return huifuIoTypeItem(value).textColor;
}
Vue.filter('huifuIoTypeTextColor', huifuIoTypeTextColor);

//汇付提现交易状态
var huifuTransStatus = [
  {
    text: i18n.t("HuifuAccount.transStatus.success"),
    color: "primary",
    textColor: "white",
    value: "S",
  },
  {
    text: i18n.t("HuifuAccount.transStatus.failed"),
    color: "danger",
    textColor: "white",
    value: "F",
  },
  {
    text: i18n.t("HuifuAccount.transStatus.process"),
    color: "action",
    textColor: "white",
    value: "P",
  },
];
// 查找汇付状态
function huifuTransStatusItem(value) {
  var item = huifuTransStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function huifuTransStatusText(value) {
  return huifuTransStatusItem(value).text;
}
Vue.filter('huifuTransStatusText', huifuTransStatusText);
function huifuTransStatusColor(value) {
  return huifuTransStatusItem(value).color;
}
Vue.filter('huifuTransStatusColor', huifuTransStatusColor);
function huifuTransStatusTextColor(value) {
  return huifuTransStatusItem(value).textColor;
}
Vue.filter('huifuTransStatusTextColor', huifuTransStatusTextColor);

// 拉卡拉提现交易状态
var lakalaTransStatus = [
  {
    text: i18n.t("LakalaCash.transStatus.unpay"),
    color: "action",
    textColor: "white",
    value: "1001",
  },
  {
    text: i18n.t("LakalaCash.transStatus.part_pay"),
    color: "action",
    textColor: "white",
    value: "1002",
  },
  {
    text: i18n.t("LakalaCash.transStatus.doing"),
    color: "action",
    textColor: "white",
    value: "1003",
  },
  {
    text: i18n.t("LakalaCash.transStatus.paid"),
    color: "primary",
    textColor: "white",
    value: "1004",
  },
  {
    text: i18n.t("LakalaCash.transStatus.deal_done"),
    color: "primary",
    textColor: "white",
    value: "1006",
  },
  {
    text: i18n.t("LakalaCash.transStatus.confirm"),
    color: "primary",
    textColor: "white",
    value: "1007",
  },
  {
    text: i18n.t("LakalaCash.transStatus.close"),
    color: "danger",
    textColor: "white",
    value: "2002",
  },
  {
    text: i18n.t("LakalaCash.transStatus.return"),
    color: "action",
    textColor: "white",
    value: "2003",
  },
];
// 查找汇付状态
function lakalaTransStatusItem(value) {
  var item = lakalaTransStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function lakalaTransStatusText(value) {
  return lakalaTransStatusItem(value).text;
}
Vue.filter('lakalaTransStatusText', lakalaTransStatusText);
function lakalaTransStatusColor(value) {
  return lakalaTransStatusItem(value).color;
}
Vue.filter('lakalaTransStatusColor', lakalaTransStatusColor);
function lakalaTransStatusTextColor(value) {
  return lakalaTransStatusItem(value).textColor;
}
Vue.filter('lakalaTransStatusTextColor', lakalaTransStatusTextColor);


//分销改价状态
var allianceSellerPriceStatus = [
  {
    text: i18n.t("Alliances.allianceSellerPrice.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Alliances.allianceSellerPrice.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找alliancesStatus
function allianceSellerPriceStatusItem(value) {
  var item = allianceSellerPriceStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function allianceSellerPriceStatusText(value) {
  return allianceSellerPriceStatusItem(value).text;
}
Vue.filter('allianceSellerPriceStatusText', allianceSellerPriceStatusText);
function allianceSellerPriceStatusColor(value) {
  return allianceSellerPriceStatusItem(value).color;
}
Vue.filter('allianceSellerPriceStatusColor', allianceSellerPriceStatusColor);
function allianceSellerPriceStatusTextColor(value) {
  return allianceSellerPriceStatusItem(value).textColor;
}
Vue.filter('allianceSellerPriceStatusTextColor', allianceSellerPriceStatusTextColor);

// 门店生成状态
var shopMade = [
  {
    text: i18n.t("Registers.status.fail"),
    color: "grey",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Registers.status.success"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
]
function shopMadeItem(value) {
  var item = shopMade.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function shopMadeText(value) {
  return shopMadeItem(value).text;
}
Vue.filter('shopMadeText', shopMadeText);
function shopMadeColor(value) {
  return shopMadeItem(value).color;
}
Vue.filter('shopMadeColor', shopMadeColor);
function shopMadeTextColor(value) {
  return shopMadeItem(value).textColor;
}
Vue.filter('shopMadeTextColor', shopMadeTextColor);



//门店状态
var shopStatus = [
  {
    text: i18n.t("Shop.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Shop.status.off"),
    color: "red",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Shop.status.stop"),
    color: "grey",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Shop.status.arrears"),
    color: "red",
    textColor: "white",
    value: 3,
  },
];
// 查找status
function shopStatusItem(value) {
  var item = shopStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function shopStatusText(value) {
  return shopStatusItem(value).text;
}
Vue.filter('shopStatusText', shopStatusText);
function shopStatusColor(value) {
  return shopStatusItem(value).color;
}
Vue.filter('shopStatusColor', shopStatusColor);
function shopStatusTextColor(value) {
  return shopStatusItem(value).textColor;
}
Vue.filter('shopStatusTextColor', shopStatusTextColor);

// 提现结果
var cashStatus = [
  {
    text: i18n.t("SubAccount.checkCash.success"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("SubAccount.checkCash.fail"),
    color: "primary",
    textColor: "white",
    value: 2,
  },

];
function cashStatusItem(value) {
  var item = cashStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function cashStatusText(value) {
  return cashStatusItem(value).text;
}
Vue.filter('cashStatusText', cashStatusText);
function cashStatusColor(value) {
  return cashStatusItem(value).color;
}
Vue.filter('cashStatusColor', cashStatusColor);
function cashStatusTextColor(value) {
  return cashStatusItem(value).textColor;
}
Vue.filter('cashStatusTextColor', cashStatusTextColor);

//门店注册状态
var shopRegFlgs = [
  {
    text: i18n.t("Shop.regFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Shop.regFlgs.on"),
    color: "grey",
    textColor: "white",
    value: 1,
  },
];
// 查找shopRegFlgs
function shopRegFlgsItem(value) {
  var item = shopRegFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function shopRegFlgsText(value) {
  return shopRegFlgsItem(value).text;
}
Vue.filter('shopRegFlgsText', shopRegFlgsText);
function shopRegFlgsColor(value) {
  return shopRegFlgsItem(value).color;
}
Vue.filter('shopRegFlgsColor', shopRegFlgsColor);
function shopRegFlgsTextColor(value) {
  return shopRegFlgsItem(value).textColor;
}
Vue.filter('shopRegFlgsTextColor', shopRegFlgsTextColor);

//门店支付设置
var shopPaySettings = [
  {
    text: i18n.t("Shop.paySettings.shop_pay_setting_one"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Shop.paySettings.shop_pay_setting_two"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Shop.paySettings.shop_pay_setting_three"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Shop.paySettings.shop_pay_setting_four"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("Shop.paySettings.shop_pay_setting_five"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("Shop.paySettings.shop_pay_setting_six"),
    color: "primary",
    textColor: "white",
    value: 6,
  },
  {
    text: i18n.t("Shop.paySettings.shop_pay_setting_seven"),
    color: "primary",
    textColor: "white",
    value: 7,
  },
];
// 查找shopPaySettings
function shopPaySettingsItem(value) {
  var item = shopPaySettings.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function shopPaySettingsText(value) {
  return shopPaySettingsItem(value).text;
}
Vue.filter('shopPaySettingsText', shopPaySettingsText);
function shopPaySettingsColor(value) {
  return shopPaySettingsItem(value).color;
}
Vue.filter('shopPaySettingsColor', shopPaySettingsColor);
function shopPaySettingsTextColor(value) {
  return shopPaySettingsItem(value).textColor;
}
Vue.filter('shopPaySettingsTextColor', shopPaySettingsTextColor);

// 新建采购 缺货状态
var isLackStatus = [
  {
    text: i18n.t("PurchasesList.status.off"),
    color: "danger",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("PurchasesList.status.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
]
function isLackStatusItem(value) {
  var item = isLackStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function isLackStatusText(value) {
  return isLackStatusItem(value).text;
}
Vue.filter('isLackStatusText', isLackStatusText);
function isLackStatusColor(value) {
  return isLackStatusItem(value).color;
}
Vue.filter('isLackStatusColor', isLackStatusColor)
function isLackStatusTextColor(value) {
  return isLackStatusItem(value).textColor;
}
Vue.filter('isLackStatusTextColor', isLackStatusTextColor)
// 采购验收
var purchaseExamineStatus = [
  {
    text: i18n.t("PurchasesList.status.wait"),
    color: "danger",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("PurchasesList.status.part"),
    color: "warning",
    textColor: "white",
    value: 3
  },
  {
    text: i18n.t("PurchasesList.status.complete"),
    color: "print",
    textColor: "white",
    value: 4
  },
  {
    text: i18n.t("PurchasesList.status.cancel"),
    color: "danger",
    textColor: "white",
    value: 99
  },
]
// 采购一览状态
var purchaseStatus = [
  {
    text: i18n.t("PurchasesList.status.new"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("PurchasesList.status.wait"),
    color: "danger",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("PurchasesList.status.part"),
    color: "warning",
    textColor: "white",
    value: 3
  },
  {
    text: i18n.t("PurchasesList.status.complete"),
    color: "print",
    textColor: "white",
    value: 4
  },
  {
    text: i18n.t("PurchasesList.status.cancel"),
    color: "danger",
    textColor: "white",
    value: 99
  },
]
// 查找status
function purchaseStatusItem(value) {
  var item = purchaseStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function purchaseStatusText(value) {
  return purchaseStatusItem(value).text;
}
Vue.filter('purchaseStatusText', purchaseStatusText);
function purchaseStatusColor(value) {
  return purchaseStatusItem(value).color;
}
Vue.filter('purchaseStatusColor', purchaseStatusColor)
function purchaseStatusTextColor(value) {
  return purchaseStatusItem(value).textColor;
}
Vue.filter('purchaseStatusTextColor', purchaseStatusTextColor)

var purchaseThirdStatus = [
  {
    text: i18n.t("PurchasesList.thirdStatus.creating"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("PurchasesList.thirdStatus.created"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("PurchasesList.thirdStatus.unsuccessful"),
    color: "primary",
    textColor: "white",
    value: 3
  },
]
// 查找status
function purchaseThirdStatusItem(value) {
  var item = purchaseThirdStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function purchaseThirdStatusText(value) {
  return purchaseThirdStatusItem(value).text;
}
Vue.filter('purchaseThirdStatusText', purchaseThirdStatusText);
function purchaseThirdStatusColor(value) {
  return purchaseThirdStatusItem(value).color;
}
Vue.filter('purchaseThirdStatusColor', purchaseThirdStatusColor)
function purchaseThirdStatusTextColor(value) {
  return purchaseThirdStatusItem(value).textColor;
}
Vue.filter('purchaseThirdStatusTextColor', purchaseThirdStatusTextColor)


// 采购一览发货状态
var purchaseDeliverFlgs = [
  {
    text: i18n.t("PurchasesList.deliveryFlgs.off"),
    color: "grey",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("PurchasesList.deliveryFlgs.on"),
    color: "primary",
    textColor: "white",
    value: 1
  },
]

// 库位流水类型
var positionActivitiesTypes = [
  {
    text: i18n.t("StockPosition.types.in"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("StockPosition.types.out"),
    color: "danger",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("StockPosition.types.move_in"),
    color: "primary",
    textColor: "white",
    value: 3
  },
  {
    text: i18n.t("StockPosition.types.move_out"),
    color: "danger",
    textColor: "white",
    value: 4
  },
  {
    text: i18n.t("StockPosition.types.surplus"),
    color: "primary",
    textColor: "white",
    value: 5
  },
  {
    text: i18n.t("StockPosition.types.loss"),
    color: "danger",
    textColor: "white",
    value: 6
  },
];

// 是否显示零商品库位
var statusFlgs = [
  {
    text: i18n.t("CurrentPosition.status.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("CurrentPosition.status.off"),
    color: "danger",
    textColor: "white",
    value: 1
  }
];

var searchTypes = [
  {
    text: i18n.t("PurchaseInventory.searchTypes.order"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("PurchaseInventory.searchTypes.stockOut"),
    color: "primary",
    textColor: "white",
    value: 2
  }
];

// 是否显示零商品库位
var zeroStatus = [
  {
    text: i18n.t("CurrentStocks.zeroStatus.positive"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("CurrentStocks.zeroStatus.negative"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("CurrentStocks.zeroStatus.zero"),
    color: "primary",
    textColor: "white",
    value: 3
  }

];

// 库存状态
var currentCountStatus = [
  {
    text: i18n.t("CurrentStocks.currentCountStatus.all"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("CurrentStocks.currentCountStatus.shortage"),
    color: "danger",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("CurrentStocks.currentCountStatus.overLoad"),
    color: "danger",
    textColor: "white",
    value: 2
  }

];

var materialsStatus = [
  {
    text: i18n.t("StockMaterials.statusFlgs.on"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("StockMaterials.statusFlgs.off"),
    color: "grey",
    textColor: "white",
    value: 0
  }
]

// 线路
var lineStatus = [
  {
    text: i18n.t("DistributionUsers.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("DistributionUsers.status.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  },
];
// 查找status
function lineStatusItem(value) {
  var item = lineStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function lineStatusText(value) {
  return lineStatusItem(value).text;
}
Vue.filter('lineStatusText', lineStatusText);
function lineStatusColor(value) {
  return lineStatusItem(value).color;
}
Vue.filter('lineStatusColor', lineStatusColor);
function lineStatusTextColor(value) {
  return lineStatusItem(value).textColor;
}
Vue.filter('lineStatusTextColor', lineStatusTextColor);
// 容器状态
var stockContainerStatus = [
  {
    text: i18n.t("StockContainers.Fields.status_on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("StockContainers.Fields.status_off"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
];
// 查找status
function stockContainerItem(value) {
  var item = stockContainerStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockContainerText(value) {
  return stockContainerItem(value).text;
}
Vue.filter('stockContainerText', stockContainerText);
function stockContainerColor(value) {
  return stockContainerItem(value).color;
}
Vue.filter('stockContainerColor', stockContainerColor);
function stockContainerTextColor(value) {
  return stockContainerItem(value).textColor;
}
Vue.filter('stockContainerTextColor', stockContainerTextColor);

var containerFlgs = [
  {
    text: i18n.t("StockContainers.Fields.status_on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("StockContainers.Fields.status_off"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
];
// 
function containerFlgsItem(value) {
  var item = containerFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function containerFlgsText(value) {
  return containerFlgsItem(value).text;
}
Vue.filter('containerFlgsText', containerFlgsText);
function containerFlgsColor(value) {
  return containerFlgsItem(value).color;
}
Vue.filter('containerFlgsColor', containerFlgsColor);
function containerFlgsTextColor(value) {
  return containerFlgsItem(value).textColor;
}
Vue.filter('containerFlgsTextColor', containerFlgsTextColor);

//仓配状态
var stockStatus = [
  {
    text: i18n.t("Stock.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Stock.status.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Stock.status.uninitialized"),
    color: "accent",
    textColor: "white",
    value: -1,
  },
];
// 查找status
function stockStatusItem(value) {
  var item = stockStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockStatusText(value) {
  return stockStatusItem(value).text;
}
Vue.filter('stockStatusText', stockStatusText);
function stockStatusColor(value) {
  return stockStatusItem(value).color;
}
Vue.filter('stockStatusColor', stockStatusColor);
function stockStatusTextColor(value) {
  return stockStatusItem(value).textColor;
}
Vue.filter('stockStatusTextColor', stockStatusTextColor);

var stockTypes = [
  {
    text: i18n.t("Stock.type.real"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Stock.type.v_auto"),
    color: "primary",
    textColor: "white",
    value: 1,
  }
];

//库位状态
var positionStatus = [
  {
    text: i18n.t("Position.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Position.status.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  }
];
// 查找status
function positionStatusItem(value) {
  var item = positionStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function positionStatusText(value) {
  return positionStatusItem(value).text;
}
Vue.filter('positionStatusText', positionStatusText);
function positionStatusColor(value) {
  return positionStatusItem(value).color;
}
Vue.filter('positionStatusColor', positionStatusColor);
function positionStatusTextColor(value) {
  return positionStatusItem(value).textColor;
}
Vue.filter('positionStatusTextColor', positionStatusTextColor);

//库位名称显示设置
var positionNameDisplaySetting = [
  {
    text: i18n.t("Position.positionNameDisplayType.position_code_and_name"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Position.positionNameDisplayType.position_name"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Position.positionNameDisplayType.stock_area_name"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Position.positionNameDisplayType.roadway_code"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
// 查找status
function positionNameDisplaySettingItem(value) {
  var item = positionNameDisplaySetting.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function positionNameDisplaySettingText(value) {
  return positionNameDisplaySettingItem(value).text;
}
Vue.filter('positionNameDisplaySettingText', positionNameDisplaySettingText);
function positionNameDisplaySettingColor(value) {
  return positionNameDisplaySettingItem(value).color;
}
Vue.filter('positionNameDisplaySettingColor', positionNameDisplaySettingColor);
function positionNameDisplaySettingTextColor(value) {
  return positionNameDisplaySettingItem(value).textColor;
}
Vue.filter('positionNameDisplaySettingTextColor', positionNameDisplaySettingTextColor);

//库位拣货状态
var positionPickingFlgs = [
  {
    text: i18n.t("Position.picking_flgs.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Position.picking_flgs.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  }
];
function positionPickingFlgsItem(value) {
  var item = positionPickingFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function positionPickingFlgsText(value) {
  return positionPickingFlgsItem(value).text;
}
Vue.filter('positionPickingFlgsText', positionPickingFlgsText);
function positionPickingFlgsColor(value) {
  return positionPickingFlgsItem(value).color;
}
Vue.filter('positionPickingFlgsColor', positionPickingFlgsColor);
function positionPickingFlgsTextColor(value) {
  return positionPickingFlgsItem(value).textColor;
}
Vue.filter('positionPickingFlgsTextColor', positionPickingFlgsTextColor);

//库位标签拣货状态
var positionLabelPickingFlgs = [
  {
    text: i18n.t("PositionLabel.picking_flgs.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("PositionLabel.picking_flgs.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  }
];
function positionLabelPickingFlgsItem(value) {
  var item = positionLabelPickingFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function positionLabelPickingFlgsText(value) {
  return positionLabelPickingFlgsItem(value).text;
}
Vue.filter('positionLabelPickingFlgsText', positionLabelPickingFlgsText);
function positionLabelPickingFlgsColor(value) {
  return positionLabelPickingFlgsItem(value).color;
}
Vue.filter('positionLabelPickingFlgsColor', positionLabelPickingFlgsColor);
function positionLabelPickingFlgsTextColor(value) {
  return positionLabelPickingFlgsItem(value).textColor;
}
Vue.filter('positionLabelPickingFlgsTextColor', positionLabelPickingFlgsTextColor);

// 库位商品绑定状态
var stockMaterialPositionStatus = [
  {
    text: i18n.t("StockDetails.StockPositionsStatus.on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("StockDetails.StockPositionsStatus.off"),
    color: "danger",
    textColor: "white",
    value: 1,
  }
];
function stockMaterialPositionStatusItem(value) {
  var item = stockMaterialPositionStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockMaterialPositionStatusText(value) {
  return stockMaterialPositionStatusItem(value).text;
}
Vue.filter('stockMaterialPositionStatusText', stockMaterialPositionStatusText);
function stockMaterialPositionStatusColor(value) {
  return stockMaterialPositionStatusItem(value).color;
}
Vue.filter('stockMaterialPositionStatusColor', stockMaterialPositionStatusColor);
function stockMaterialPositionStatusTextColor(value) {
  return stockMaterialPositionStatusItem(value).textColor;
}
Vue.filter('stockMaterialPositionStatusTextColor', stockMaterialPositionStatusTextColor);

//库位标签状态
var positionLabelStatus = [
  {
    text: i18n.t("PositionLabel.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("PositionLabel.status.off"),
    color: "grey",
    textColor: "white",
    value: 0,
  }
];
function positionLabelStatusItem(value) {
  var item = positionLabelStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function positionLabelStatusText(value) {
  return positionLabelStatusItem(value).text;
}
Vue.filter('positionLabelStatusText', positionLabelStatusText);
function positionLabelStatusColor(value) {
  return positionLabelStatusItem(value).color;
}
Vue.filter('positionLabelStatusColor', positionLabelStatusColor);
function positionLabelStatusTextColor(value) {
  return positionLabelStatusItem(value).textColor;
}
Vue.filter('positionLabelStatusTextColor', positionLabelStatusTextColor);

//库区类型
var stockAreaType = [
  {
    text: i18n.t("StockArea.type.pick"),
    color: "action",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockArea.type.store"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("StockArea.type.temp"),
    color: "warning",
    textColor: "white",
    value: 3,
  }
];
function stockAreaTypeItem(value) {
  var item = stockAreaType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockAreaTypeText(value) {
  return stockAreaTypeItem(value).text;
}
Vue.filter('stockAreaTypeText', stockAreaTypeText);
function stockAreaTypeColor(value) {
  return stockAreaTypeItem(value).color;
}
Vue.filter('stockAreaTypeColor', stockAreaTypeColor);
function stockAreaTypeTextColor(value) {
  return stockAreaTypeItem(value).textColor;
}
Vue.filter('stockAreaTypeTextColor', stockAreaTypeTextColor);

//上架策略类型
var positionShelveType = [
  {
    text: i18n.t("WaveRules.PutawayStrategy.default_position"),
    color: "primary",
    textColor: "white",
    value: 1,
    hint: i18n.t("WaveRules.PutawayStrategy.default_position_hint"),
  },
  {
    text: i18n.t("WaveRules.PutawayStrategy.maximum_available_position"),
    color: "primary",
    textColor: "white",
    value: 2,
    hint: i18n.t("WaveRules.PutawayStrategy.available_position_hint"),
  },
  {
    text: i18n.t("WaveRules.PutawayStrategy.minimum_available_position"),
    color: "primary",
    textColor: "white",
    value: 3,
    hint: i18n.t("WaveRules.PutawayStrategy.available_position_hint"),
  },
  {
    text: i18n.t("WaveRules.PutawayStrategy.empty_position"),
    color: "primary",
    textColor: "white",
    value: 4,
    hint: i18n.t("WaveRules.PutawayStrategy.empty_position_hint"),
  }
];
function positionShelveTypeItem(value) {
  var item = positionShelveType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function positionShelveTypeText(value) {
  return positionShelveTypeItem(value).text;
}
Vue.filter('positionShelveTypeText', positionShelveTypeText);
function positionShelveTypeColor(value) {
  return positionShelveTypeItem(value).color;
}
Vue.filter('positionShelveTypeColor', positionShelveTypeColor);
function positionShelveTypeTextColor(value) {
  return positionShelveTypeItem(value).textColor;
}
Vue.filter('positionShelveTypeTextColor', positionShelveTypeTextColor);

//移库方式
var movePositionOrderWays = [
  {
    text: i18n.t("MovePositionOrder.moveWay.manual_move_order"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MovePositionOrder.moveWay.auto_move_order"),
    color: "primary",
    textColor: "white",
    value: 2,
  }
];
function movePositionOrderWaysItem(value) {
  var item = movePositionOrderWays.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function movePositionOrderWaysText(value) {
  return movePositionOrderWaysItem(value).text;
}
Vue.filter('movePositionOrderWaysText', movePositionOrderWaysText);
function movePositionOrderWaysColor(value) {
  return movePositionOrderWaysItem(value).color;
}
Vue.filter('movePositionOrderWaysColor', movePositionOrderWaysColor);
function movePositionOrderWaysTextColor(value) {
  return movePositionOrderWaysItem(value).textColor;
}
Vue.filter('movePositionOrderWaysTextColor', movePositionOrderWaysTextColor);

//移库类型
var movePositionOrderTypes = [
  {
    text: i18n.t("MovePositionOrder.type.stock_position"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MovePositionOrder.type.material"),
    color: "primary",
    textColor: "white",
    value: 2,
  }
];
function movePositionOrderTypesItem(value) {
  var item = movePositionOrderTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function movePositionOrderTypesText(value) {
  return movePositionOrderTypesItem(value).text;
}
Vue.filter('movePositionOrderTypesText', movePositionOrderTypesText);
function movePositionOrderTypesColor(value) {
  return movePositionOrderTypesItem(value).color;
}
Vue.filter('movePositionOrderTypesColor', movePositionOrderTypesColor);
function movePositionOrderTypesTextColor(value) {
  return movePositionOrderTypesItem(value).textColor;
}
Vue.filter('movePositionOrderTypesTextColor', movePositionOrderTypesTextColor);

//移库单状态
var movePositionOrderCancelFlgs = [
  {
    text: i18n.t("CancelFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("CancelFlgs.on"),
    color: "grey",
    textColor: "white",
    value: 1,
  }
];
function movePositionOrderCancelFlgsItem(value) {
  var item = movePositionOrderCancelFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function movePositionOrderCancelFlgsText(value) {
  return movePositionOrderCancelFlgsItem(value).text;
}
Vue.filter('movePositionOrderCancelFlgsText', movePositionOrderCancelFlgsText);
function movePositionOrderCancelFlgsColor(value) {
  return movePositionOrderCancelFlgsItem(value).color;
}
Vue.filter('movePositionOrderCancelFlgsColor', movePositionOrderCancelFlgsColor);
function movePositionOrderCancelFlgsTextColor(value) {
  return movePositionOrderCancelFlgsItem(value).textColor;
}
Vue.filter('movePositionOrderCancelFlgsTextColor', movePositionOrderCancelFlgsTextColor);

//盘点单状态
var stockTakeOrderStatus = [
  {
    text: i18n.t("StockTakeOrders.orderStatus.wait_stock_take"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockTakeOrders.orderStatus.already_stock_take"),
    color: "primary",
    textColor: "white",
    value: 2,
  }
];
function stockTakeOrderStatusItem(value) {
  var item = stockTakeOrderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockTakeOrderStatusText(value) {
  return stockTakeOrderStatusItem(value).text;
}
Vue.filter('stockTakeOrderStatusText', stockTakeOrderStatusText);
function stockTakeOrderStatusColor(value) {
  return stockTakeOrderStatusItem(value).color;
}
Vue.filter('stockTakeOrderStatusColor', stockTakeOrderStatusColor);
function stockTakeOrderStatusTextColor(value) {
  return stockTakeOrderStatusItem(value).textColor;
}
Vue.filter('stockTakeOrderStatusTextColor', stockTakeOrderStatusTextColor);

//调拨单状态
var requisitionStatus = [
  {
    text: i18n.t("Requisition.status.wait_approval"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Requisition.status.wait_stock_out"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Requisition.status.wait_stock_in"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Requisition.status.finished"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  // {
  //   text: i18n.t("Requisition.status.cancelled"),
  //   color: "grey",
  //   textColor: "white",
  //   value: -1,
  // },
];
function requisitionStatusItem(value) {
  var item = requisitionStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function requisitionStatusText(value) {
  return requisitionStatusItem(value).text;
}
Vue.filter('requisitionStatusText', requisitionStatusText);
function requisitionStatusColor(value) {
  return requisitionStatusItem(value).color;
}
Vue.filter('requisitionStatusColor', requisitionStatusColor);
function requisitionStatusTextColor(value) {
  return requisitionStatusItem(value).textColor;
}
Vue.filter('requisitionStatusTextColor', requisitionStatusTextColor);

//调拨单类型
var requisitionTypes = [
  {
    text: i18n.t("Requisition.types.regular"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Requisition.types.premuim"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Requisition.types.return"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Requisition.types.sale"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("Requisition.types.sale_return"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("Requisition.types.purchase"),
    color: "primary",
    textColor: "white",
    value: 6,
  },
  {
    text: i18n.t("Requisition.types.purchase_return"),
    color: "primary",
    textColor: "white",
    value: 7,
  },
];
function requisitionTypesItem(value) {
  var item = requisitionTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function requisitionTypesText(value) {
  return requisitionTypesItem(value).text;
}
Vue.filter('requisitionTypesText', requisitionTypesText);
function requisitionTypesColor(value) {
  return requisitionTypesItem(value).color;
}
Vue.filter('requisitionTypesColor', requisitionTypesColor);
function requisitionTypesTextColor(value) {
  return requisitionTypesItem(value).textColor;
}
Vue.filter('requisitionTypesTextColor', requisitionTypesTextColor);

//生产计划单状态
var productionPlansStatus = [
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.wait_confirm"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.wait_approve"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.wait_stock_out"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.wait_stock_in"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.finished"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
];
function productionPlansStatusItem(value) {
  var item = productionPlansStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function productionPlansStatusText(value) {
  return productionPlansStatusItem(value).text;
}
Vue.filter('productionPlansStatusText', productionPlansStatusText);
function productionPlansStatusColor(value) {
  return productionPlansStatusItem(value).color;
}
Vue.filter('productionPlansStatusColor', productionPlansStatusColor);
function productionPlansStatusTextColor(value) {
  return productionPlansStatusItem(value).textColor;
}
Vue.filter('productionPlansStatusTextColor', productionPlansStatusTextColor);

//生产计划单类型
var productionPlansType = [
  {
    text: i18n.t("ProductionPlans.productionType.production_combined"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ProductionPlans.productionType.production_split"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];
function productionPlansTypeItem(value) {
  var item = productionPlansType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function productionPlansTypeText(value) {
  return productionPlansTypeItem(value).text;
}
Vue.filter('productionPlansTypeText', productionPlansTypeText);
function productionPlansTypeColor(value) {
  return productionPlansTypeItem(value).color;
}
Vue.filter('productionPlansTypeColor', productionPlansTypeColor);
function productionPlansTypeTextColor(value) {
  return productionPlansTypeItem(value).textColor;
}
Vue.filter('productionPlansTypeTextColor', productionPlansTypeTextColor);

var logTypes = [
  {
    text: i18n.t("AccountLogs.Types.login"),
    value: "0",
  },
  {
    text: i18n.t("AccountLogs.Types.account_order"),
    value: "1",
  },
  {
    text: i18n.t("AccountLogs.Types.stock_management"),
    value: "2",
  },
  {
    text: i18n.t("AccountLogs.Types.material_management"),
    value: "3",
  },

  {
    text: i18n.t("AccountLogs.Types.importers_management"),
    value: "5",
  },
  {
    text: i18n.t("AccountLogs.Types.fund_management"),
    value: "6",
  },
  {
    text: i18n.t("AccountLogs.Types.customer_maintenance"),
    value: "7",
  },
  {
    text: i18n.t("AccountLogs.Types.settings"),
    value: "8",
  },
  {
    text: i18n.t("AccountLogs.Types.report"),
    value: "9",
  },
  {
    text: i18n.t("AccountLogs.Types.return_order_management"),
    value: "10",
  },
  {
    text: i18n.t("AccountLogs.Types.purchase_management"),
    value: "11",
  },
  {
    text: i18n.t("AccountLogs.Types.stock_position"),
    value: "12",
  },
  {
    text: i18n.t("AccountLogs.Types.message_management"),
    value: "13",
  },
  {
    text: i18n.t("AccountLogs.Types.production_management"),
    value: "14",
  },
  {
    text: i18n.t("AccountLogs.Types.set_shop_psi"),
    value: "16",
  },
  {
    text: i18n.t("AccountLogs.Types.currency"),
    value: "900",
  },
  {
    text: i18n.t("AccountLogs.Types.supplier_applet"),
    value: "901",
  },
  {
    text: i18n.t("AccountLogs.Types.supplier_web"),
    value: "902",
  },
  {
    text: i18n.t("AccountLogs.Types.shop_currency"),
    value: "910",
  },
  {
    text: i18n.t("AccountLogs.Types.shop_applet"),
    value: "911",
  },
  {
    text: i18n.t("AccountLogs.Types.shop_web"),
    value: "912",
  },
  {
    text: i18n.t("AccountLogs.Types.ENT"),
    value: "999",
  },
  {
    text: i18n.t("AccountLogs.Types.page_access"),
    value: "-1",
  },
]
function logTypesItem(value) {
  var item = logTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Order.originFlgs.default"),
    value: "000",
  };
}
function logTypesText(value) {
  return logTypesItem(value).text;
}
Vue.filter('logTypesText', logTypesText);
function logTypesColor() {
  return "";
}
Vue.filter('logTypesColor', logTypesColor);
function logTypesTextColor() {
  return "";
}
Vue.filter('logTypesTextColor', logTypesTextColor);

var queueDataTypes = [
  {
    text: i18n.t("queueDataLogs.Types.shop_auto_order"),
    value: "1",
  },
  {
    text: i18n.t("queueDataLogs.Types.shop_analyze"),
    value: "2",
  },
  {
    text: i18n.t("queueDataLogs.Types.sync_material"),
    value: "3",
  },
  {
    text: i18n.t("queueDataLogs.Types.sync_shop"),
    value: "4",
  },
  {
    text: i18n.t("queueDataLogs.Types.sync_sale_out"),
    value: "6",
  },
  {
    text: i18n.t("queueDataLogs.Types.sync_pay"),
    value: "7",
  },
  {
    text: i18n.t("queueDataLogs.Types.sync_sale_in"),
    value: "8",
  },
  {
    text: i18n.t("queueDataLogs.Types.action_order_confirm"),
    value: "10",
  },
  {
    text: i18n.t("queueDataLogs.Types.action_order_approve"),
    value: "12",
  },
  {
    text: i18n.t("queueDataLogs.Types.action_order_cancel"),
    value: "13",
  },
  {
    text: i18n.t("queueDataLogs.Types.action_stock_out"),
    value: "14",
  },
  {
    text: i18n.t("queueDataLogs.Types.shop_stock_take_plan"),
    value: "15",
  },
]
function queueDataTypesItem(value) {
  var item = queueDataTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    value: "000",
  };
}
function queueDataTypesText(value) {
  return queueDataTypesItem(value).text;
}
Vue.filter('queueDataTypesText', queueDataTypesText);

//要货规则是否启用
var queueDataStatus = [
  {
    text: i18n.t("queueDataLogs.status.new"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("queueDataLogs.status.ok"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("queueDataLogs.status.err"),
    color: "danger",
    textColor: "white",
    value: 2,
  },
];
function queueDataStatusItem(value) {
  var item = queueDataStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function queueDataStatusText(value) {
  return queueDataStatusItem(value).text;
}
Vue.filter('queueDataStatusText', queueDataStatusText);
function queueDataStatusColor(value) {
  return queueDataStatusItem(value).color;
}
Vue.filter('queueDataStatusColor', queueDataStatusColor);
function queueDataStatusTextColor(value) {
  return queueDataStatusItem(value).textColor;
}
Vue.filter('queueDataStatusTextColor', queueDataStatusTextColor);

//下单周期类型
var orderCycleType = [
  {
    text: i18n.t("OrderCycles.type.cycle_type_zero"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("OrderCycles.type.cycle_type_one"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  // {
  //   text: i18n.t("OrderCycles.type.cycle_type_two"),
  //   color: "primary",
  //   textColor: "white",
  //   value: 2,
  // },
  // {
  //   text: i18n.t("OrderCycles.type.cycle_type_three"),
  //   color: "primary",
  //   textColor: "white",
  //   value: 3,
  // },
];
// 查找type
function orderCycleTypeItem(value) {
  var item = orderCycleType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function orderCycleTypeText(value) {
  return orderCycleTypeItem(value).text;
}
Vue.filter('orderCycleTypeText', orderCycleTypeText);
function orderCycleTypeColor(value) {
  return orderCycleTypeItem(value).color;
}
Vue.filter('orderCycleTypeColor', orderCycleTypeColor);
function orderCycleTypeTextColor(value) {
  return orderCycleTypeItem(value).textColor;
}
Vue.filter('orderCycleTypeTextColor', orderCycleTypeTextColor);

//下单周期日期设置
var orderCycleWeekSetting = [
  {
    text: i18n.t("OrderCycles.cycleWeek.weekday"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("OrderCycles.cycleWeek.monday"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("OrderCycles.cycleWeek.tuesday"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("OrderCycles.cycleWeek.wednesday"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("OrderCycles.cycleWeek.thursday"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("OrderCycles.cycleWeek.friday"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("OrderCycles.cycleWeek.saturday"),
    color: "primary",
    textColor: "white",
    value: 6,
  },
];
// 查找type
function orderCycleWeekSettingItem(value) {
  var item = orderCycleWeekSetting.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function orderCycleWeekSettingText(value) {
  return orderCycleWeekSettingItem(value).text;
}
Vue.filter('orderCycleWeekSettingText', orderCycleWeekSettingText);
function orderCycleWeekSettingColor(value) {
  return orderCycleWeekSettingItem(value).color;
}
Vue.filter('orderCycleWeekSettingColor', orderCycleWeekSettingColor);
function orderCycleWeekSettingTextColor(value) {
  return orderCycleWeekSettingItem(value).textColor;
}
Vue.filter('orderCycleWeekSettingTextColor', orderCycleWeekSettingTextColor);

//下单周期周期设置
var orderCycleDaySetting = [
  {
    text: i18n.t("OrderCycles.cycleDay.today"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("OrderCycles.cycleDay.tommorrow"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("OrderCycles.cycleDay.the_day_after_tommorrow"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("OrderCycles.cycleDay.three_days_later"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("OrderCycles.cycleDay.four_days_later"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("OrderCycles.cycleDay.five_days_later"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("OrderCycles.cycleDay.six_days_later"),
    color: "primary",
    textColor: "white",
    value: 6,
  },
];
// 查找type
function orderCycleDaySettingItem(value) {
  var item = orderCycleDaySetting.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function orderCycleDaySettingText(value) {
  return orderCycleDaySettingItem(value).text;
}
Vue.filter('orderCycleDaySettingText', orderCycleDaySettingText);
function orderCycleDaySettingColor(value) {
  return orderCycleDaySettingItem(value).color;
}
Vue.filter('orderCycleDaySettingColor', orderCycleDaySettingColor);
function orderCycleDaySettingTextColor(value) {
  return orderCycleDaySettingItem(value).textColor;
}
Vue.filter('orderCycleDaySettingTextColor', orderCycleDaySettingTextColor);

var qacenterStatus = [
  {
    text: i18n.t("Complaint.status.Pending"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Complaint.status.processing"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Complaint.status.processed"),
    color: "primary",
    textColor: "white",
    value: 0,
  }
]
function qacenterItem(value) {
  var item = qacenterStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Order.originFlgs.default"),
    value: "000",
  };
}
function qacenterText(value) {
  return qacenterItem(value).text;
}
Vue.filter('qacenterText', qacenterText);
function qacenterColor(value) {
  return qacenterItem(value).color;
}
Vue.filter('qacenterColor', qacenterColor);
function qacenterTextColor(value) {
  return qacenterItem(value).textColor;
}
Vue.filter('qacenterTextColor', qacenterTextColor);

var announcementStatus = [
  {
    text: i18n.t("Announcement.status.hide"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Announcement.status.display"),
    color: "primary",
    textColor: "white",
    value: 1,
  },

]
function announcementItem(value) {
  var item = announcementStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Announcement.status.default"),
    value: "000",
  };
}
function announcementText(value) {
  return announcementItem(value).text;
}
Vue.filter('announcementText', announcementText);
function announcementColor(value) {
  return announcementItem(value).color;
}
Vue.filter('announcementColor', announcementColor);
function announcementTextColor(value) {
  return announcementItem(value).textColor;
}
Vue.filter('announcementTextColor', announcementTextColor);

var redOffsetStatus = [
  {
    text: i18n.t("billRecords.isRedOffset.yes"),
    color: "red",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("billRecords.isRedOffset.no"),
    color: "red",
    textColor: "white",
    value: 0,
  },

]
function redOffsetItem(value) {
  var item = redOffsetStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("billRecords.isRedOffset.default"),
    value: "000",
  };
}
function redOffsetText(value) {
  return redOffsetItem(value).text;
}
Vue.filter('redOffsetText', redOffsetText);
function redOffsetColor(value) {
  return redOffsetItem(value).color;
}
Vue.filter('redOffsetColor', redOffsetColor);
function redOffsetTextColor(value) {
  return redOffsetItem(value).textColor;
}
Vue.filter('redOffsetTextColor', redOffsetTextColor);

var shopStockTakePlansStatus = [
  {
    text: i18n.t("shopStockTakePlans.status.status_zero"),
    color: "red",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("shopStockTakePlans.status.status_one"),
    color: "orange",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("shopStockTakePlans.status.status_two"),
    color: "primary",
    textColor: "white",
    value: 2,
  },

]
function shopStockTakePlansItem(value) {
  var item = shopStockTakePlansStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("shopStockTakePlans.status.default"),
    value: "000",
  };
}
function shopStockTakePlansText(value) {
  return shopStockTakePlansItem(value).text;
}
Vue.filter('shopStockTakePlansText', shopStockTakePlansText);
function shopStockTakePlansColor(value) {
  return shopStockTakePlansItem(value).color;
}
Vue.filter('shopStockTakePlansColor', shopStockTakePlansColor);
function shopStockTakePlansTextColor(value) {
  return shopStockTakePlansItem(value).textColor;
}
Vue.filter('shopStockTakePlansTextColor', shopStockTakePlansTextColor);

var shopStockTakePlansCancelFlg = [
  {
    text: i18n.t("shopStockTakePlans.cancel_flg.cancel_flg_off"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("shopStockTakePlans.cancel_flg.cancel_flg_on"),
    color: "grey",
    textColor: "white",
    value: 1,
  },
]
function shopStockTakePlansCancelFlgItem(value) {
  var item = shopStockTakePlansCancelFlg.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("shopStockTakePlans.status.default"),
    value: "000",
  };
}
function shopStockTakePlansCancelFlgText(value) {
  return shopStockTakePlansCancelFlgItem(value).text;
}
Vue.filter('shopStockTakePlansCancelFlgText', shopStockTakePlansCancelFlgText);
function shopStockTakePlansCancelFlgColor(value) {
  return shopStockTakePlansCancelFlgItem(value).color;
}
Vue.filter('shopStockTakePlansCancelFlgColor', shopStockTakePlansCancelFlgColor);
function shopStockTakePlansCancelFlgTextColor(value) {
  return shopStockTakePlansCancelFlgItem(value).textColor;
}
Vue.filter('shopStockTakePlansCancelFlgTextColor', shopStockTakePlansCancelFlgTextColor);

var shopStockTakePlansOverFlg = [
  {
    text: i18n.t("shopStockTakePlans.over_flg.over_flg_false"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("shopStockTakePlans.over_flg.over_flg_true"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
]


var campaignsType = [
  {
    text: i18n.t("Campaigns.status.pub_flg_1"),
    color: "orange",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Campaigns.status.pub_flg_2"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Campaigns.status.pub_flg_3"),
    color: "gray",
    textColor: "black",
    value: 2,
  },
  {
    text: i18n.t("Campaigns.status.pub_flg_4"),
    color: "accent",
    textColor: "white",
    value: 3,
  },

]
function CampaignsItem(value) {
  var item = campaignsType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Announcement.status.default"),
    value: "000",
  };
}
function CampaignsText(value) {
  return CampaignsItem(value).text;
}
Vue.filter('CampaignsText', CampaignsText);
function CampaignsColor(value) {
  return CampaignsItem(value).color;
}
Vue.filter('CampaignsColor', CampaignsColor);
function CampaignsTextColor(value) {
  return CampaignsItem(value).textColor;
}
Vue.filter('CampaignsTextColor', CampaignsTextColor);

//促销活动类型
var activitiesType = [
  {
    name: i18n.t("Campaigns.activities.type2"),
    description: i18n.t("Campaigns.activities.description2"),
    template: i18n.t("Campaigns.activities.template2"),
    type: 102,
  },
  {
    name: i18n.t("Campaigns.activities.type3"),
    description: i18n.t("Campaigns.activities.description3"),
    template: i18n.t("Campaigns.activities.template3"),
    type: 103,
  },
  {
    name: i18n.t("Campaigns.activities.type1"),
    description: i18n.t("Campaigns.activities.description1"),
    template: i18n.t("Campaigns.activities.template1"),
    type: 101,
  },
  {
    name: i18n.t("Campaigns.activities.type8"),
    description: i18n.t("Campaigns.activities.description8"),
    template: i18n.t("Campaigns.activities.template8"),
    type: 108,
  },
  {
    name: i18n.t("Campaigns.activities.type9"),
    description: i18n.t("Campaigns.activities.description9"),
    template: i18n.t("Campaigns.activities.template9"),
    type: 109,
  },
  {
    name: i18n.t("Campaigns.activities.type7"),
    description: i18n.t("Campaigns.activities.description7"),
    template: i18n.t("Campaigns.activities.template7"),
    type: 107,
  },
]
// function ActivitiesItem(value) {
//   var item = activitiesType.find((element) => element.value == value);
//   return item ? item : {
//     text: i18n.t("Announcement.status.default"),
//     value: "000",
//   };
// }
// function ActivitiesText(value) {
//   return ActivitiesItem(value).text;
// }
// Vue.filter('ActivitiesText', ActivitiesText);
// function ActivitiesColor(value) {
//   return ActivitiesItem(value).color;
// }
// Vue.filter('ActivitiesColor', ActivitiesColor);
// function ActivitiesTextColor(value) {
//   return ActivitiesItem(value).textColor;
// }
// Vue.filter('ActivitiesTextColor', ActivitiesTextColor);
//下单周期周期设置
var sexFlgs = [
  {
    text: i18n.t("AccountUser.sexFlgs.man"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("AccountUser.sexFlgs.woman"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];
// 查找type
function sexFlgsItem(value) {
  var item = sexFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function sexFlgsText(value) {
  return sexFlgsItem(value).text;
}
Vue.filter('sexFlgsText', sexFlgsText);
function sexFlgsColor(value) {
  return sexFlgsItem(value).color;
}
Vue.filter('sexFlgsColor', sexFlgsColor);
function sexFlgsTextColor(value) {
  return sexFlgsItem(value).textColor;
}
Vue.filter('sexFlgsTextColor', sexFlgsTextColor);

//要货规则必须验证类型
var mustVerifyFlgs = [
  {
    text: i18n.t("MaterialOrderRule.munstVerifyFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialOrderRule.munstVerifyFlgs.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
function mustVerifyFlgsItem(value) {
  var item = mustVerifyFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function mustVerifyFlgsText(value) {
  return mustVerifyFlgsItem(value).text;
}
Vue.filter('mustVerifyFlgsText', mustVerifyFlgsText);
function mustVerifyFlgsColor(value) {
  return mustVerifyFlgsItem(value).color;
}
Vue.filter('mustVerifyFlgsColor', mustVerifyFlgsColor);
function mustVerifyFlgsTextColor(value) {
  return mustVerifyFlgsItem(value).textColor;
}
Vue.filter('mustVerifyFlgsTextColor', mustVerifyFlgsTextColor);

//要货规则适用方式
var applicationWays = [
  {
    text: i18n.t("MaterialOrderRule.applicationWays.off"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialOrderRule.applicationWays.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
function applicationWaysItem(value) {
  var item = applicationWays.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function applicationWaysText(value) {
  return applicationWaysItem(value).text;
}
Vue.filter('applicationWaysText', applicationWaysText);
function applicationWaysColor(value) {
  return applicationWaysItem(value).color;
}
Vue.filter('applicationWaysColor', applicationWaysColor);
function applicationWaysTextColor(value) {
  return applicationWaysItem(value).textColor;
}
Vue.filter('applicationWaysTextColor', applicationWaysTextColor);//要货规则适用方式

// 发现内容类型
var accountAdsTypes = [
  {
    text: i18n.t("AccountAds.detailType.external"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("AccountAds.detailType.local"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("AccountAds.detailType.broadcast"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 小程序模板三公告类型
var announcementTypes = [
  {
    text: i18n.t("Announcement.types.type_one"),
    value: 1,
  },
  {
    text: i18n.t("Announcement.types.type_two"),
    value: 2,
  },
];
function accountAdsTypesItem(value) {
  var item = accountAdsTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function accountAdsTypesText(value) {
  return accountAdsTypesItem(value).text;
}
Vue.filter('accountAdsTypesText', accountAdsTypesText);
function accountAdsTypesColor(value) {
  return accountAdsTypesItem(value).color;
}
Vue.filter('accountAdsTypesColor', accountAdsTypesColor);
function accountAdsTypesTextColor(value) {
  return accountAdsTypesItem(value).textColor;
}
Vue.filter('accountAdsTypesTextColor', accountAdsTypesTextColor);

// 活动范围areaTypes
var areaTypes = [
  {
    text: i18n.t("MaterialOrderRule.expressFee.rangeDetail.group"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MaterialOrderRule.expressFee.rangeDetail.cities"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
]
function rangeTypesItem(value) {
  var item = areaTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function rangeTypesText(value) {
  return rangeTypesItem(value).text;
}
Vue.filter('rangeTypesText', rangeTypesText);
function rangeTypesColor(value) {
  return rangeTypesItem(value).color;
}
Vue.filter('rangeTypesColor', rangeTypesColor);
function rangeTypesTextColor(value) {
  return rangeTypesItem(value).textColor;
}
Vue.filter('rangeTypesTextColor', rangeTypesTextColor);

// 品类选择categoryMatchTypes
var categoryMatchTypes = [
  {
    text: i18n.t("MaterialOrderRule.expressFee.categoryMatchDetail.all"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialOrderRule.expressFee.categoryMatchDetail.category"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
]
function categoryMatchTypesItem(value) {
  var item = categoryMatchTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function categoryMatchTypesText(value) {
  return categoryMatchTypesItem(value).text;
}
Vue.filter('categoryMatchTypesText',categoryMatchTypesText);
function categoryMatchTypesColor(value) {
  return categoryMatchTypesItem(value).color;
}
Vue.filter('categoryMatchTypesColor', categoryMatchTypesColor);
function categoryMatchTypesTextColor(value) {
  return categoryMatchTypesItem(value).textColor;
}
Vue.filter('categoryMatchTypesTextColor', categoryMatchTypesTextColor);

//限定类型
var numTypes = [
  {
    text: i18n.t("MaterialOrderRule.maxOrderRule.numTypesDetail.order"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MaterialOrderRule.maxOrderRule.numTypesDetail.day"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
]
function numTypesItem(value) {
  var item = numTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function numTypesText(value) {
  return numTypesItem(value).text;
}
Vue.filter('numTypesText',numTypesText);

// 分账类型是否必选
var requireTypes = [
  {
    text: i18n.t("SubAccountSettings.yes"),
    color: "primary",
    textColor: "white",
    value: "1",
  },
  {
    text: i18n.t("SubAccountSettings.no"),
    color: "primary",
    textColor: "white",
    value: "0",
  },
]
function requireTypesItem(value) {
  var item = requireTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function requireTypesText(value) {
  return requireTypesItem(value).text;
}
Vue.filter('requireTypesText', requireTypesText);

// 是否默认为运费账户
var expressTypes = [
  {
    text: i18n.t("SubAccountSettings.yes"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("SubAccountSettings.no"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
]
function expressTypesItem(value) {
  var item = expressTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function expressTypesText(value) {
  return expressTypesItem(value).text;
}
Vue.filter('expressTypesText', expressTypesText);
function expressTypesColor(value) {
  return expressTypesItem(value).color;
}
Vue.filter('expressTypesColor', expressTypesColor);
function expressTypesTextColor(value) {
  return expressTypesItem(value).textColor;
}
Vue.filter('expressTypesTextColor', expressTypesTextColor);

// 是否默认为余额支付账户
var balanceTypes = [
  {
    text: i18n.t("SubAccountSettings.yes"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("SubAccountSettings.no"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
]
function balanceTypesItem(value) {
  var item = balanceTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function balanceTypesText(value) {
  return balanceTypesItem(value).text;
}
Vue.filter('balanceTypesText', balanceTypesText);
function balanceTypesColor(value) {
  return balanceTypesItem(value).color;
}
Vue.filter('balanceTypesColor', balanceTypesColor);
function balanceTypesTextColor(value) {
  return balanceTypesItem(value).textColor;
}
Vue.filter('balanceTypesTextColor', balanceTypesTextColor);

var memberType = [
  {
    text: i18n.t("SubAccountSettings.member_type.individual"),
    value: 2,
  },
  {
    text: i18n.t("SubAccountSettings.member_type.corporate"),
    value: 3,
  },
  {
    text: i18n.t("SubAccountSettings.member_type.individual_business"),
    value: 4,
  },
]

// 运费计算依据
var expressPayTypes = [
  {
    text: i18n.t("MaterialOrderRule.expressFee.feeDetail.price"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MaterialOrderRule.expressFee.feeDetail.number"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("MaterialOrderRule.expressFee.feeDetail.pcs"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("MaterialOrderRule.expressFee.feeDetail.weight"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("MaterialOrderRule.expressFee.feeDetail.price_percent"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
function expressPayTypesItem(value) {
  var item = expressPayTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function expressPayTypesText(value) {
  return expressPayTypesItem(value).text;
}
Vue.filter('expressPayTypesText', expressPayTypesText);
function expressPayTypesColor(value) {
  return expressPayTypesItem(value).color;
}
Vue.filter('expressPayTypesColor', expressPayTypesColor);
function expressPayTypesTextColor(value) {
  return expressPayTypesItem(value).textColor;
}
Vue.filter('expressPayTypesTextColor', expressPayTypesTextColor);

// 活动范围
var districtsTypes = [
  {
    text: i18n.t("Campaigns.Fields.allShops"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Campaigns.Fields.group"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Campaigns.Fields.shops"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
function districtsTypesItem(value) {
  var item = districtsTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function districtsTypesText(value) {
  return districtsTypesItem(value).text;
}
Vue.filter('districtsTypesText', districtsTypesText);
function districtsTypesColor(value) {
  return districtsTypesItem(value).color;
}
Vue.filter('districtsTypesColor', districtsTypesColor);
function districtsTypesTextColor(value) {
  return districtsTypesItem(value).textColor;
}
Vue.filter('districtsTypesTextColor', districtsTypesTextColor);

// 使用商品
var materialsTypes = [
  {
    text: i18n.t("Campaigns.Fields.allMaterials"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Campaigns.Fields.category"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Campaigns.Fields.material"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
function materialsTypesItem(value) {
  var item = materialsTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function materialsTypesText(value) {
  return materialsTypesItem(value).text;
}
Vue.filter('materialsTypesText', materialsTypesText);
function materialsTypesColor(value) {
  return materialsTypesItem(value).color;
}
Vue.filter('materialsTypesColor', materialsTypesColor);
function materialsTypesTextColor(value) {
  return materialsTypesItem(value).textColor;
}
Vue.filter('materialsTypesTextColor', materialsTypesTextColor);

//要货规则是否启用
var orderRuleStatus = [
  {
    text: i18n.t("MaterialOrderRule.statusFlgs.off"),
    color: "danger",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialOrderRule.statusFlgs.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
function orderRuleStatusItem(value) {
  var item = orderRuleStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function orderRuleStatusText(value) {
  return orderRuleStatusItem(value).text;
}
Vue.filter('orderRuleStatusText', orderRuleStatusText);
function orderRuleStatusColor(value) {
  return orderRuleStatusItem(value).color;
}
Vue.filter('orderRuleStatusColor', orderRuleStatusColor);
function orderRuleStatusTextColor(value) {
  return orderRuleStatusItem(value).textColor;
}
Vue.filter('orderRuleStatusTextColor', orderRuleStatusTextColor);

// 分账是否启用
var accountStatus = [
  {
    text: i18n.t("SubAccountSettingPort.off"),
    color: "gray",
    textColor: "black",
    value: 0,
  },
  {
    text: i18n.t("SubAccountSettingPort.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
function accountStatusItem(value) {
  var item = accountStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function accountStatusText(value) {
  return accountStatusItem(value).text;
}
Vue.filter('accountStatusText', accountStatusText);
function accountStatusColor(value) {
  return accountStatusItem(value).color;
}
Vue.filter('accountStatusColor', accountStatusColor);
function accountStatusTextColor(value) {
  return accountStatusItem(value).textColor;
}
Vue.filter('accountStatusTextColor', accountStatusTextColor);


//要货规则进位方式
var roundNumbersTypes = [
  {
    text: i18n.t("MaterialOrderRule.roundNumbersTypes.one"),
    color: "primary",
    textColor: "white",
    value: "1",
  },
  {
    text: i18n.t("MaterialOrderRule.roundNumbersTypes.two"),
    color: "primary",
    textColor: "white",
    value: "2",
  },
  {
    text: i18n.t("MaterialOrderRule.roundNumbersTypes.three"),
    color: "primary",
    textColor: "white",
    value: "3",
  },
];
function roundNumbersTypesItem(value) {
  var item = roundNumbersTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function roundNumbersTypesText(value) {
  return roundNumbersTypesItem(value).text;
}
Vue.filter('roundNumbersTypesText', roundNumbersTypesText);
function roundNumbersTypesColor(value) {
  return roundNumbersTypesItem(value).color;
}
Vue.filter('roundNumbersTypesColor', roundNumbersTypesColor);
function roundNumbersTypesTextColor(value) {
  return roundNumbersTypesItem(value).textColor;
}
Vue.filter('roundNumbersTypesTextColor', roundNumbersTypesTextColor);

//菜品分账类型
var subAccountConfigTypes = [
  {
    text: i18n.t("SubAccountConfig.types.dishConfigs"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("SubAccountConfig.types.materialConfigs"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];
function subAccountConfigTypesItem(value) {
  var item = subAccountConfigTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function subAccountConfigTypesText(value) {
  return subAccountConfigTypesItem(value).text;
}
Vue.filter('subAccountConfigTypesText', subAccountConfigTypesText);
function subAccountConfigTypesColor(value) {
  return subAccountConfigTypesItem(value).color;
}
Vue.filter('subAccountConfigTypesColor', subAccountConfigTypesColor);
function subAccountConfigTypesTextColor(value) {
  return subAccountConfigTypesItem(value).textColor;
}
Vue.filter('subAccountConfigTypesTextColor', subAccountConfigTypesTextColor);

//菜品分账是否是默认规则
var subAccountConfigStatus = [
  {
    text: i18n.t("SubAccountConfig.status.on"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("SubAccountConfig.status.off"),
    color: "danger",
    textColor: "white",
    value: 0,
  },
];

//
var couponType = [
  {
    text: i18n.t("MaterialCoupons.Types.voucher"),
    value: 1,
  },
  {
    text: i18n.t("MaterialCoupons.Types.discount"),
    value: 2,
  },
];

var couponStatus = [
  {
    text: i18n.t("MaterialCoupons.Status.on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialCoupons.Status.off"),
    color: "grey",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MaterialCoupons.Status.cancel"),
    color: "grey",
    textColor: "white",
    value: 2
  },
];

var couponUseFlgs = [
  {
    text: i18n.t("MaterialCoupons.use_flgs.on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialCoupons.use_flgs.off"),
    color: "grey",
    textColor: "white",
    value: 1,
  },
];


var prescriptionType = [
  {
    text: i18n.t("MaterialCoupons.PrescriptionType.spending"),
    value: 1,
  },
  {
    text: i18n.t("MaterialCoupons.PrescriptionType.no_threshold"),
    value: 2,
  },
];

var newFlg = [
  {
    text: i18n.t("MaterialCoupons.NewFlg.restriction"),
    value: 1,
  },
  {
    text: i18n.t("MaterialCoupons.NewFlg.no_restriction"),
    value: 0,
  },
];

var useType = [
  {
    text: i18n.t("MaterialCoupons.useType.spending"),
    value: 1,
  },
  {
    text: i18n.t("MaterialCoupons.useType.no_threshold"),
    value: 2,
  },
];

var couponMaterialTypes = [
  {
    text: i18n.t("Campaigns.Fields.allMaterials"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Campaigns.Fields.category"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Campaigns.Fields.material"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];

function couponMaterialTypesItem(value) {
  var item = couponMaterialTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function couponMaterialTypesText(value) {
  return couponMaterialTypesItem(value).text;
}
Vue.filter('couponMaterialTypesText', couponMaterialTypesText);

var couponDistrictTypes = [
  {
    text: i18n.t("Campaigns.Fields.allShops"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Campaigns.Fields.group"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Campaigns.Fields.shops"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];

function couponDistrictTypesItem(value) {
  var item = couponDistrictTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function couponDistrictTypesText(value) {
  return couponDistrictTypesItem(value).text;
}
Vue.filter('couponDistrictTypesText', couponDistrictTypesText);


function subAccountConfigStatusItem(value) {
  var item = subAccountConfigStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function subAccountConfigStatusText(value) {
  return subAccountConfigStatusItem(value).text;
}
Vue.filter('subAccountConfigStatusText', subAccountConfigStatusText);
function subAccountConfigStatusColor(value) {
  return subAccountConfigStatusItem(value).color;
}
Vue.filter('subAccountConfigStatusColor', subAccountConfigStatusColor);
function subAccountConfigStatusTextColor(value) {
  return subAccountConfigStatusItem(value).textColor;
}
Vue.filter('subAccountConfigStatusTextColor', subAccountConfigStatusTextColor);

var cloudPrinterMaxStr = [
  {
    text: i18n.t("cloudPrinterSetting.settings.58mm"),
    color: "primary",
    textColor: "white",
    value: 32,
  },
  {
    text: i18n.t("cloudPrinterSetting.settings.80mm"),
    color: "primary",
    textColor: "white",
    value: 48,
  },
];

function cloudPrinterMaxStrItem(value) {
  var item = cloudPrinterMaxStr.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function cloudPrinterMaxStrText(value) {
  return cloudPrinterMaxStrItem(value).text;
}
Vue.filter('cloudPrinterMaxStrText', cloudPrinterMaxStrText);

var expectDateType = [
  {
    text: i18n.t("PreSell.expect_date_type.day"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("PreSell.expect_date_type.date"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
]

function expectDateTypeItem(value) {
  var item = expectDateType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function expectDateTypeText(value) {
  return expectDateTypeItem(value).text;
}
Vue.filter('expectDateTypeText', expectDateTypeText);

var expectDays = [
  {
    text: i18n.t("PreSell.expect_day.firstDay"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("PreSell.expect_day.secondDay"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("PreSell.expect_day.thirDay"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
]

function expectDaysItem(value) {
  var item = expectDays.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function expectDaysText(value) {
  return expectDaysItem(value).text;
}
Vue.filter('expectDaysText', expectDaysText);


function getDayStart() {
  var from = new Date();
  from.setHours(0, 0, 0, 0);
  return from;
}
function getDayEnd() {
  var end = new Date();
  end.setHours(23, 59, 59, 999);
  return end;
}
export default {
  shopName,
  allianceName,
  maxValue,
  limitAll: 10000000,
  cancelFlgs,
  prohibitFlgs,
  expiredFlgs,
  outInFlgs,
  statusFlgs,
  searchTypes,
  netFlgs,
  positionActivitiesTypes,
  public_flg,
  purchaseStatus,
  purchaseExamineStatus,
  purchaseDeliverFlgs,
  origin_flgs,
  supply_type,
  stop_flg,
  financeFlgs,
  beyondStatus,
  financeStatus,
  financeBillType,
  billFlgs,
  billCheckFlg,
  billTypes,
  objType,
  purchaseBillTypes,
  stockBillTypes,
  BillTypes,
  billObjType,
  operationType,
  payTypeArr,
  payTypeReceipt,
  billTypeReceipt,
  cashType,
  lklCcashType,
  cashStatus,
  cardtype,
  logTypes,
  queueDataTypes,
  queueDataStatus,
  qacenterStatus,
  announcementStatus,
  redOffsetStatus,
  shopStockTakePlansStatus,
  shopStockTakePlansCancelFlg,
  shopStockTakePlansOverFlg,
  campaignsType,
  activitiesType,
  shopMade,
  announcementTypes,
  legal_cert_type,
  cloudPrinterMaxStr,
  account_user: {
    sex: sexFlgs,
  },
  orderOriginFlgs,
  account_ads: {
    content_type: accountAdsTypes,
  },
  coupons: {
    coupon_type: couponType,
    coupon_status: couponStatus,
    coupon_use_flgs:couponUseFlgs,
    prescription_type: prescriptionType,
    new_flg: newFlg,
    use_type: useType,
    coupon_material_types: couponMaterialTypes,
    coupon_district_types: couponDistrictTypes
  },
  order: {
    status: orderStatus,
    // origin_flgs: orderOriginFlgs(),
    error_flg: orderErrorFlg,
    presale_flg: presaleFlgs
  },
  currentStocks: {
    zeroStatus: zeroStatus,
    materialsStatus: materialsStatus,
    currentCountStatus: currentCountStatus
  },
  return_order: {
    status: returnOrderStatus,
    type: returnOrderTypes,
    return_origin_flgs: returnOriginFlgs
  },
  return_purchase: {
    status: returnPurchaseStatus,
    type: returnPurchaseTypes
  },
  return_basket: {
    status: returnBasketStatus,
  },
  subAccountSettingsPort: {
    accountStatus: accountStatus
  },
  distribution: {
    status: distributionStatus,
    is_print: distributionPrintStatus
  },
  examine: {
    status: examineStatus,
    abnormal_flgs: examineAbnormalFlgs,
    is_abnormal: examineIsAbnormaled,
    examine_flgs: examineFlgs,
  },
  purchase: {
    third_status: purchaseThirdStatus,
  },
  quotation: {
    status: quotationStatus,
    question_flgs: quotationQuestionFlgs,
    use_flgs: quotationUseFlgs,
  },
  economy: {
    status: economyStatus,
  },
  purchasePlans:{
    status: purchasePlansStatus
  },
  purchaseTasks:{
    status: purchaseTasksStatus
  },
  stock_in_order: {
    status: stockOrderINStatus,
    types: stockOrderINTypes,
    shopTypes: stockOrderInShopTypes
  },
  stock_out_order: {
    status: stockOrderOUTStatus,
    types: stockOrderOUTTypes,
    brokenType: stockOrderOUTBrokenType,
    third_status: stockOrderOUTThirdStatus,
    is_print: stockOrderOUTPrintStatus,
    sorting_status: stockOrderSortingStatus,
    shopTypes: stockOrderOutShopTypes,
  },
  waveRules: {
    pick_type: pickOrderTypes,
    pick_way: pickOrderWays,
    area_split_ruler: areaSplitRulers,
    status: waveRulerStatus,
  },
  wave: {
    status: waveStatus,
  },
  bill: {
    status: billStatus,
    pay_flgs: billPayFlgs,
  },
  use: {
    use_status: useStatus
  },
  alliance: {
    status: alliancesStatus,
    alliance_seller_price: allianceSellerPriceStatus,
  },
  shop: {
    status: shopStatus,
    reg_flgs: shopRegFlgs,
    pay_settings: shopPaySettings,
  },
  stock: {
    status: stockStatus,
    position_shelve_strategy: positionShelveType,
    types: stockTypes,
  },
  container: {
    status: stockContainerStatus,
    container_flgs: containerFlgs
  },
  position: {
    status: positionStatus,
    picking_flgs: positionPickingFlgs,
    position_name_display: positionNameDisplaySetting,
  },
  positionLabel: {
    status: positionLabelStatus,
    picking_flgs: positionLabelPickingFlgs
  },
  stockMaterialPosition: {
    status: stockMaterialPositionStatus,
  },
  stockArea: {
    type: stockAreaType,
  },
  movePositionOrder: {
    way: movePositionOrderWays,
    type: movePositionOrderTypes,
    cancel_flgs: movePositionOrderCancelFlgs,
  },
  stockTakeOrder: {
    status: stockTakeOrderStatus,
  },
  requisition: {
    status: requisitionStatus,
    types: requisitionTypes,
  },
  pruductionPlan: {
    status: productionPlansStatus,
    type: productionPlansType,
  },
  line: {
    status: lineStatus,
  },
  orderRule: {
    must_flgs: mustVerifyFlgs,
    match_flgs: applicationWays,
    status: orderRuleStatus,
    round_numbers_types: roundNumbersTypes,
    pay_types: expressPayTypes,
    range_types: areaTypes,
    category_match_types: categoryMatchTypes,
    num_types:numTypes
  },
  campaign: {
    districts_types:districtsTypes,
    materials_types:materialsTypes
  },
  subAccountSettings: {
    require_types: requireTypes,
    express_types: expressTypes,
    balance_types: balanceTypes,
    member_type: memberType,
  },
  subAccountConfigs: {
    types: subAccountConfigTypes,
    status: subAccountConfigStatus,

  },
  huifu: {
    huifu_status: huifuStatus,
    legal_cert_type: legal_cert_type,
    huifu_card_type: huifuCardType,
    huifu_io_type: huifuIoType
  },
  dateTimeRangeShortcuts: [
    {
      text: i18n.t("$datetime.shortcuts.today"),
      onClick: () => {
        return [getDayStart(), getDayEnd()];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.yesterday"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 6);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(from.getMonth() - 1);
        from.setDate(from.getDate() + 1);
        return [from, end];
      },
    },
    // {
    //   text: i18n.t("$datetime.shortcuts.inHalfYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setMonth(from.getMonth() - 6);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    // {
    //   text: i18n.t("$datetime.shortcuts.inOneYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setFullYear(from.getFullYear() - 1);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    {
      text: i18n.t("$datetime.shortcuts.thisWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
           day = 7
         }
        from.setDate(from.getDate() - day + 1);
        end.setDate(end.getDate() + 7 - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
          day = 7
        }
        from.setDate(from.getDate() - 6 - day);
        end.setDate(end.getDate() - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        end.setMonth(end.getMonth() + 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        from.setMonth(from.getMonth() - 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        end.setFullYear(end.getFullYear() + 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        from.setFullYear(from.getFullYear() - 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
  ],
  orderCycle: {
    type: orderCycleType,
    day: orderCycleDaySetting,
    week: orderCycleWeekSetting,
  },
  tableOptions: {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: 30,
    multiSort: true,
    mustSort: false,
    page: 1,
    sortBy: [],
    sortDesc: [],
  },
  PreSell: {
    types: expectDateType,
    days:expectDays
  }
}